// Auto-generated — refresh via scripts/translate-ui-google-free.mjs
// Placeholders repaired via scripts/repair-ui-placeholders.mjs

export const UI_MESSAGES_ID: Record<string, string> = {
  'maintenance.title': 'Sedang dalam pemeliharaan',
  'maintenance.defaultMessage':
    'Sistem sedang dalam pemeliharaan dan sementara tidak tersedia. Silakan coba lagi nanti.',
  'common.loading': 'Memuat…',
  'common.datePlaceholder': 'Pilih tanggal',
  'common.openCalendarAria': 'Buka kalender untuk memilih tanggal',
  'common.cancel': 'Membatalkan',
  'common.close': 'Menutup',
  'common.closeViewer': 'Tutup pratinjau',
  'common.imageViewer.zoomHint': 'Pinch to zoom; ketuk dua kali untuk mengatur ulang; atau gunakan + / − di bawah',
  'common.imageViewer.zoomInAria': 'Perbesar',
  'common.imageViewer.zoomOutAria': 'Perkecil',
  'common.imageViewer.resetZoomAria': 'Setel ulang zoom',
  'common.imageViewer.scalePercent': '{{percent}}%',
  'common.confirm': 'Mengonfirmasi',
  'common.next': 'Berikutnya',
  'common.back': 'Kembali',
  'common.save': 'Menyimpan',
  'common.appTagline': 'Manajemen Beranda Tangga bagi Majikan dan Pembantu',
  'common.languageSwitcherAria': 'Bahasa antarmuka',
  'notFound.title': 'Halaman tidak ditemukan',
  'notFound.body': 'Halaman yang Anda cari tidak ada atau telah dihapus.',
  'language.zhHant': 'Bahasa Tionghoa Tradisional',
  'language.zhHans': 'Bahasa Tionghoa Sederhana',
  'language.en': 'Bahasa Inggris',
  'language.id': 'Bahasa Indonesia',
  'language.fil': 'Bahasa Filipina',
  'legal.contentEnglishNotice': 'Konten halaman ini ditampilkan dalam bahasa Inggris.',
  'login.title': 'Login',
  'login.subtitle': 'Masuk dengan email dan kata sandi Anda',
  'auth.errorGeneric': 'Ada yang tidak beres. Silakan coba lagi.',
  'auth.emailLabel': 'E-mail',
  'auth.passwordLabel': 'Kata sandi',
  'auth.rememberMe': 'Ingat saya',
  'auth.forgotPasswordLink': 'Lupa kata sandi?',
  'auth.signIn': 'Masuk',
  'auth.signInWithGoogle': 'Masuk dengan Google',
  'auth.signingIn': 'Masuk…',
  'auth.linkRegister': 'Buat akun',
  'auth.linkLogin': 'Sudah punya akun? Masuk',
  'auth.registerTitle': 'Buat akun',
  'auth.registerSubtitle': 'Pilih peran Anda dan masukkan detail Anda',
  'auth.roleLabel': 'Peran',
  'auth.roleRequired': 'Silakan pilih peran terlebih dahulu.',
  'auth.passwordRulesHint': '8–16 karakter dengan huruf besar, huruf kecil, dan angka',
  'auth.nicknameLabel': 'Nama panggilan',
  'auth.pairingCodeOptional': 'Kode penyandingan (opsional)',
  'auth.pairingCodePlaceholder': '6 karakter',
  'auth.pairingCodeHint': 'Jika majikan Anda memberi Anda kode, masukkan di sini. Anda juga bisa mendaftar terlebih dahulu dan memasukkan kodenya di halaman pairing nanti.',
  'auth.invitationCodeLabel': 'Kode undangan',
  'auth.invitationCodeOptional': 'Kode undangan (opsional)',
  'auth.invitationCodePlaceholder': '8 karakter',
  'auth.invitationCodeHint': 'Masukkan kode undangan jika ada.',
  'auth.invitationCodeRequired': 'Silakan masukkan kode undangan',
  'auth.invitationCodeValid': 'Kode undangan valid',
  'auth.invitationCodeBenefitL1Extend': 'Perpanjang uji coba {{days}} hari',
  'auth.invitationCodeBenefitL3Trial': 'Uji coba anggota berbayar {{days}} hari',
  'auth.invitationCodeInvalid': 'Kode undangan tidak valid',
  'auth.invitationCodeErrorFormat': 'Format kode undangan tidak valid',
  'auth.invitationCodeErrorNotYetActive': 'Kode undangan belum aktif',
  'auth.invitationCodeErrorExpired': 'Kode undangan telah kedaluwarsa',
  'auth.invitationCodeErrorDisabled': 'Kode undangan dinonaktifkan',
  'auth.invitationCodeErrorMaxUses': 'Kode undangan telah mencapai batas penggunaannya',
  'auth.invitationCodeErrorAfterRegistrationOnly':
    'Kode undangan ini hanya bisa ditukar setelah pendaftaran',
  'auth.invitationCodeDeepLinkInvalid':
    'Tautan undangan ini tidak valid atau sudah tidak tersedia. Masukkan kode undangan lain yang valid jika ada.',
  'auth.invitationCodeLockedHint':
    'Kode undangan ini berasal dari tautan undangan dan tidak dapat diubah saat pendaftaran.',
  'inviteReferrer.menuItem': 'Penggunaan kode undangan',
  'inviteReferrer.pageTitle': 'Penggunaan kode undangan',
  'inviteReferrer.pageSubtitle':
    'Lihat berapa banyak orang yang menggunakan kode undangan Anda untuk mendaftar atau menukar, dan berapa yang menjadi pengguna berbayar.',
  'inviteReferrer.statsLabel': 'Statistik kode undangan',
  'inviteReferrer.code': 'Kode undangan',
  'inviteReferrer.benefit': 'Manfaat kode',
  'inviteReferrer.benefitL1Extend': 'Perpanjang uji coba {{days}} hari',
  'inviteReferrer.benefitL3Trial': 'Uji coba anggota premium {{days}} hari',
  'inviteReferrer.maxUses': 'Batas penggunaan',
  'inviteReferrer.maxUsesLimited': '{{used}} / {{max}}',
  'inviteReferrer.maxUsesUnlimited': '{{used}} / Tanpa batas',
  'inviteReferrer.validity': 'Masa berlaku',
  'inviteReferrer.validityRange': '{{start}} — {{end}}',
  'inviteReferrer.validityImmediate': 'Berlaku segera',
  'inviteReferrer.validityPermanent': 'Tanpa tanggal akhir',
  'inviteReferrer.totalUses': 'Jumlah penggunaan',
  'inviteReferrer.paidUsers': 'Pengguna berbayar',
  'inviteReferrer.shareLink': 'Tautan berbagi',
  'inviteReferrer.copyLink': 'Salin tautan',
  'inviteReferrer.copied': 'Disalin',
  'inviteReferrer.notBound': 'Anda belum terikat sebagai perujuk kode undangan.',
  'auth.registerCta': 'Daftar',
  'auth.registerWithGoogle': 'Daftar ke Google',
  'auth.registering': 'Mendaftar…',
  'auth.registerRoleConfirmTitle': 'Konfirmasikan peran pendaftaran Anda',
  'auth.registerRoleConfirmDescription': 'Peran yang Anda pilih adalah "{{role}}". Mohon konfirmasi kebenarannya. Peran Anda tidak dapat diubah setelah pendaftaran.',
  'auth.registerPicsScrollRequired': 'Silakan gulir Pernyataan Pengumpulan Informasi Pribadi (PICS) ke bawah terlebih dahulu.',
  'auth.registerPicsAgreeRequired': 'Silakan centang kotak untuk menyetujui Pernyataan Pengumpulan Informasi Pribadi.',
  'auth.forgotTitle': 'Lupa kata sandi',
  'auth.forgotSubtitle': 'Masukkan email Anda dan kami akan mengirimkan link reset jika akun ada.',
  'auth.forgotSubmit': 'Kirim tautan setel ulang',
  'auth.forgotSending': 'Mengirim…',
  'auth.forgotSuccess': 'Jika email tersebut terdaftar, Anda akan segera menerima email pengaturan ulang kata sandi.',
  'auth.resetTitle': 'Setel ulang kata sandi',
  'auth.resetSubtitle': 'Pilih kata sandi baru.',
  'auth.newPasswordLabel': 'Kata sandi baru',
  'auth.confirmPasswordLabel': 'Konfirmasikan kata sandi baru',
  'auth.resetSubmit': 'Setel ulang kata sandi',
  'auth.resetting': 'Menyetel ulang…',
  'auth.passwordMismatch': 'Kata sandi tidak cocok',
  'auth.showPassword': 'Menunjukkan',
  'auth.hidePassword': 'Bersembunyi',
  'auth.confirmPasswordRegisterLabel': 'Konfirmasikan kata sandi',
  'auth.resetSuccess': 'Kata sandi Anda telah disetel ulang. Silakan masuk.',
  'auth.goToLogin': 'Pergi untuk masuk',
  'auth.goToHome': 'Pergi ke beranda',
  'auth.verifyTitle': 'Verifikasi email',
  'auth.verifyPending': 'Memverifikasi…',
  'auth.verifySuccess': 'Email berhasil diverifikasi.',
  'auth.verifyFail': 'Verifikasi gagal. Tautan tersebut mungkin telah kedaluwarsa.',
  'auth.missingToken': 'Tautan verifikasi tidak valid atau hilang.',
  'auth.accountRemovalConfirmTitle': 'Konfirmasi penghapusan akun',
  'auth.accountRemovalConfirmPrompt': 'Akun Anda akan langsung dihapus setelah Anda menekan tombol di bawah. Tindakan ini tidak dapat dibatalkan.',
  'auth.accountRemovalConfirmButton': 'Konfirmasi dan hapus akun',
  'auth.accountRemovalConfirmPending': 'Menghapus akun Anda…',
  'auth.accountRemovalConfirmSuccess': 'Akun Anda telah dihapus.',
  'auth.accountRemovalConfirmFail': 'Konfirmasi gagal. Tautan tersebut mungkin telah kedaluwarsa.',
  'auth.googleCallbackTitle': 'Masuk dengan Google',
  'auth.googleCallbackLoading': 'Menyelesaikan otentikasi Google. Harap tunggu…',
  'auth.googleDecisionNotRegistered': 'Tidak ada catatan pendaftaran yang ditemukan untuk akun Google ini. Apakah Anda ingin mendaftar sekarang?',
  'auth.googleDecisionRegisteredGoogle': 'Catatan pendaftaran Google sudah ada. Apakah Anda ingin masuk sekarang?',
  'auth.googleDecisionRegisteredEmail': 'Akun email/kata sandi sudah ada untuk email ini. Apakah Anda ingin masuk dengan email saja?',
  'auth.googleDecisionConfirmRegister': 'Ya, daftar sekarang',
  'auth.googleDecisionConfirmLogin': 'Ya, masuk sekarang',
  'auth.googleDecisionConfirmEmailLogin': 'Ya, gunakan login email',
  'auth.googleDecisionCancelHome': 'Tidak, kembali ke rumah',
  'auth.registerWizardStepBadge': 'Langkah {{current}} dari {{total}}',
  'auth.registerWizardProgressAria': 'Kemajuan pendaftaran',
  'auth.registerMethodTitle': 'Buat akun',
  'auth.registerMethodSubtitle': 'Pilih bagaimana Anda ingin mendaftar ke MaidEasy.',
  'auth.registerDividerOrEmail': 'Atau daftar dengan email',
  'auth.registerEmailHelper': 'Kami akan mengirimkan link verifikasi ke email ini.',
  'auth.registerContinueWithEmail': 'Lanjutkan dengan email',
  'auth.registerStepRoleTitle': 'Pilih peran Anda',
  'auth.registerStepRoleSubtitle': 'Silakan pilih apakah Anda seorang Majikan atau Pembantu. Hal ini tidak dapat diubah nanti.',
  'auth.registerRoleImportantNotice': 'Penting: Setelah Anda memilih peran dan menyelesaikan pendaftaran, peran tersebut tidak dapat diubah. Pastikan Anda memilih peran yang benar.',
  'auth.registerRoleEmployerTitle': 'Pemberi pekerjaan',
  'auth.registerRoleEmployerDesc': 'Saya ingin mengelola tugas, pengeluaran, dan terhubung dengan pembantu saya.',
  'auth.registerRoleHelperTitle': 'Pembantu',
  'auth.registerRoleHelperDesc': 'Saya ingin melihat tugas harian saya, mengirimkan tanda terima, dan melacak pekerjaan saya.',
  'auth.registerStepNicknameTitle': 'Masukkan detailnya',
  'auth.registerStepNicknameSubtitle': 'Nama ini ditampilkan kepada pihak berpasangan Anda; wilayah penggunaan dan nama panggilan dapat diubah nanti di Pengaturan.',
  'auth.registerStepPasswordTitle': 'Tetapkan kata sandi Anda',
  'auth.registerStepPasswordSubtitle': 'Harap buat kata sandi yang aman untuk melindungi akun Anda.',
  'auth.registerPasswordPolicyTitle': 'Kata sandi setidaknya harus berisi:',
  'auth.registerPasswordPolicyLength': '8–16 karakter',
  'auth.registerPasswordPolicyUpper': 'Satu huruf besar (A–Z)',
  'auth.registerPasswordPolicyLower': 'Satu huruf kecil (a–z)',
  'auth.registerPasswordPolicyDigit': 'Satu angka (0–9)',
  'auth.registerStepPairingTitle': 'Kode penyandingan (opsional)',
  'auth.registerStepPairingSubtitle': 'Jika perusahaan Anda membagikan kode penyandingan 6 karakter, masukkan di sini. Anda juga dapat membiarkannya kosong dan memasangkannya nanti.',
  'auth.registerStepPicsScrollFirst': 'Gulir pernyataan di bawah ini ke bawah sebelum Anda dapat mencentang persetujuan.',
  'auth.registerContinue': 'Melanjutkan',
  'auth.registerStepReviewTitle': 'Tinjau detail Anda',
  'auth.registerStepReviewSubtitle': 'Harap konfirmasi bahwa informasi di bawah ini benar. Gunakan Edit untuk kembali ke satu langkah.',
  'auth.registerReviewMethod': 'Metode pendaftaran',
  'auth.registerReviewMethodEmail': 'E-mail',
  'auth.registerReviewMethodGoogle': 'Google',
  'auth.registerReviewRole': 'Peran akun',
  'auth.registerReviewEmail': 'Alamat email',
  'auth.registerReviewNickname': 'Nama panggilan',
  'auth.registerReviewUsageRegion': 'Wilayah penggunaan',
  'auth.registerReviewPairing': 'Kode berpasangan',
  'auth.registerReviewPairingEmpty': '(Tidak disediakan)',
  'auth.registerReviewInvitationCode': 'Kode undangan',
  'auth.registerReviewInvitationCodeEmpty': 'Tidak digunakan',
  'auth.registerReviewPicsAgreed': 'Anda telah menyetujui Pernyataan Pengumpulan Informasi Pribadi (PICS) dan persyaratan pemrosesan data.',
  'auth.registerReviewEdit': 'Sunting',
  'auth.registerCompleteRegistration': 'Pendaftaran lengkap',
  'auth.registerCompleteTitle': 'Pendaftaran selesai',
  'auth.registerCompleteEmailVerify': 'Kami telah mengirimkan email verifikasi. Silakan periksa kotak masuk Anda (dan spam) dan klik tautan untuk memverifikasi.',
  'auth.registerCompleteGoogle': 'Akun Google Anda telah diverifikasi. Anda dapat terus menggunakan MaidEasy.',
  'auth.registerCompleteContinue': 'Melanjutkan',
  'auth.emailTaken': 'Email ini sudah terdaftar',
  'auth.emailChecking': 'Memeriksa email…',
  'auth.emailInvalid': 'Silakan masukkan alamat email yang valid',
  'home.navLogin': 'Masuk',
  'home.navLoginEmail': 'Masuk email',
  'home.navGoogleLogin': 'Masuk dengan Google',
  'home.navRegister': 'Daftar',
  'home.registerModalTitle': 'Pilih metode pendaftaran',
  'home.registerModalSubtitle': 'Silakan pilih registrasi Google atau registrasi email.',
  'home.registerWithGoogle': 'Daftar ke Google',
  'home.registerWithEmail': 'Daftar dengan email',
  'home.navLogout': 'Keluar',
  'home.navPairing': 'Status berpasangan',
  'home.navEmployerApp': 'Tugas (majikan)',
  'home.navHelperApp': 'Tugas hari ini (pembantu)',
  'home.phaseLine': '',
  'home.linkPrivacy': 'Kebijakan Privasi',
  'home.linkTerms': 'Ketentuan Layanan',
  'home.linkPics': 'GAMBAR',
  'home.linkFaq': 'Pertanyaan Umum',
  'home.linkFeatures': 'Pengenalan Fitur',
  'home.linkFeaturesAria': 'Pengenalan Fitur (buka tab baru)',
  'faq.title': 'Pertanyaan yang Sering Diajukan',
  'faq.subtitle': 'Lihat konten FAQ berdasarkan peran.',
  'faq.tabHelper': 'Pembantu',
  'faq.tabEmployer': 'Pemberi pekerjaan',
  'faq.loadError': 'Tidak dapat memuat FAQ.',
  'faq.empty': 'Belum ada konten FAQ.',
  'nav.home': 'Beranda',
  'systemMessage.menu': 'Pesan sistem',
  'systemMessage.list.title': 'Pesan sistem',
  'systemMessage.list.empty': 'Belum ada pesan sistem.',
  'systemMessage.list.colSubject': 'Subjek',
  'systemMessage.list.colDate': 'Tanggal',
  'systemMessage.list.openItem': 'Buka: {{subject}}',
  'systemMessage.ticker.title': 'Pesan sistem',
  'systemMessage.ticker.count': '{{current}} / {{total}}',
  'systemMessage.ticker.openDetails': 'Lihat detail pesan sistem',
  'systemMessage.ticker.prev': 'Pesan sistem sebelumnya',
  'systemMessage.ticker.next': 'Pesan sistem berikutnya',
  'systemMessage.action.close': 'Tutup',
  'systemMessage.detailEmpty': '(Tidak ada detail)',
  'systemMessage.error.loadList': 'Gagal memuat pesan sistem',
  'systemMessage.image.enlargeAria': 'Perbesar gambar',
  'systemMessage.image.openLinkAria': 'Buka tautan',
  'systemMessage.menuItemUnreadAria': '{{label}}, {{count}} belum dibaca',
  'nav.tasks': 'Tugas',
  'nav.expensesSettlements': 'Pengeluaran',
  'nav.expensesSettlementsHelper': 'Pengeluaran',
  'nav.family': 'Keluarga',
  'nav.stock': 'Saham',
  'nav.mainAria': 'Navigasi bawah aplikasi utama',
  'pwa.offlineBanner': 'Offline — Aplikasi ini untuk sementara tidak tersedia hingga jaringan Anda pulih.',
  'pwa.syncing': 'Menyinkronkan…',
  'pwa.syncComplete': 'Sinkronisasi selesai',
  'pwa.syncFailed': 'Sinkronisasi gagal — coba lagi',
  'pwa.pendingSync': 'Item menunggu sinkronisasi',
  'pwa.installCta': 'Instal aplikasi',
  'pwa.installDismiss': 'Tutup',
  'playBanner.subtitle': 'MaidEasy - Di Google Play',
  'playBanner.install': 'Instal',
  'playBanner.installAria': 'Instal MaidEasy di Google Play',
  'playBanner.dismissAria': 'Tutup spanduk instalasi',
  'playBanner.regionAria': 'Petunjuk instalasi Google Play',
  'task.complete.savedOffline': 'Disimpan di perangkat ini; akan disinkronkan saat online',
  'receipt.analyze.savedOffline': 'Disimpan di perangkat ini; akan disinkronkan saat online',
  'legal.privacy.title': 'Kebijakan Privasi',
  'legal.privacy.body': 'Halaman ini adalah konten hukum pengganti. Kebijakan ini menjelaskan cara kami mengumpulkan, menggunakan, dan melindungi data pribadi, dan akan ditinjau secara hukum sebelum diproduksi.',
  'legal.terms.title': 'Ketentuan Layanan',
  'legal.terms.body': 'Halaman ini adalah konten hukum pengganti. Penggunaan layanan ini tunduk pada ketentuan yang harus diselesaikan sebelum peluncuran produksi.',
  'legal.pics.title': 'Pernyataan Pengumpulan Informasi Pribadi (PICS)',
  'legal.pics.body': 'Placeholder PICS multi-bahasa yang selaras dengan alur pendaftaran; salinan akhir setelah tinjauan hukum/kepatuhan.',
  'legal.backHome': 'Kembali ke rumah',
  'settings.title': 'Pengaturan',
  'settings.subtitle': 'Bahasa, zona waktu, tampilan, dan notifikasi',
  'settings.nicknameLabel': 'Nama panggilan',
  'settings.nicknamePlaceholder': 'Masukkan nama panggilan Anda',
  'settings.languageLabel': 'Bahasa tampilan',
  'settings.timezoneLabel': 'Zona waktu',
  'settings.usageRegionLabel': 'Wilayah penggunaan',
  'settings.themeLabel': 'Tema',
  'settings.themeLight': 'Lampu',
  'settings.themeDark': 'Gelap',
  'settings.themeSystem': 'Sistem',
  'settings.fontSizeLabel': 'Ukuran huruf',
  'settings.fontXSmall': 'Sangat kecil',
  'settings.fontSmall': 'Kecil',
  'settings.fontMedium': 'Sedang',
  'settings.fontLarge': 'Besar',
  'settings.fontXLarge': 'Ekstra besar',
  'settings.aiUsageTitle': 'Penggunaan AI saat ini',
  'settings.aiUsageHint': 'Tanda terima AI dan analisis stok rumah (direset setiap hari pada pukul 00:00 UTC)',
  'settings.receiptUsageTitle': 'Penggunaan scan resi hari ini',
  'settings.receiptUsageHint': 'Tanda terima yang dapat Anda kirimkan per hari (direset setiap hari pada pukul 00:00 UTC)',
  'settings.aiUsageLoading': 'Memuat…',
  'settings.dailyUsageError': 'Tidak dapat memuat penggunaan sehari-hari',
  'usage.pageTitle': 'Ringkasan penggunaan',
  'usage.pageSubtitle': 'Kuota harian dan batas tugas',
  'usage.backToSettings': 'Kembali ke pengaturan',
  'usage.taskSubmitTitle': 'Penggunaan kirim tugas hari ini',
  'usage.taskSubmitHint': 'Pengiriman tugas per hari (direset setiap hari pada pukul 00:00 UTC)',
  'usage.taskReviewTitle': 'Penggunaan tinjau tugas hari ini',
  'usage.taskReviewHint': 'Tinjauan tugas per hari (direset setiap hari pada pukul 00:00 UTC)',
  'usage.totalTasksTitle': 'Total tugas dibuat',
  'usage.totalTasksHint': 'Slot tugas dalam pasangan (tugas diarsipkan tidak dihitung)',
  'usage.pinMessagesTitle': 'Total pesan pin',
  'usage.pinMessagesHint': 'Jumlah pesan pin dalam pasangan (kumulatif)',
  'usage.resetAtLabel': 'Reset berikutnya',
  'usage.unlimited': 'Tak terbatas',
  'usage.viewUsageDetails': 'Lihat detail penggunaan',
  'usage.membershipLevel': 'Level keanggotaan',
  'usage.levelTrial': 'Anggota percobaan',
  'usage.levelFree': 'Anggota gratis',
  'usage.levelPaid': 'Anggota premium',
  'usage.helperMembershipHelpTriggerAria': 'Lihat bantuan level keanggotaan',
  'usage.helperMembershipHelpAria': 'Bantuan level keanggotaan',
  'usage.helperMembershipHelpTitle': 'Level keanggotaan',
  'usage.helperMembershipHelpFollowsEmployer':
    'Asisten rumah tangga tidak dapat meningkatkan level keanggotaan sendiri. Level keanggotaan mengikuti akun majikan.',
  'usage.helperMembershipHelpContactEmployer':
    'Jika kuota penggunaan tidak cukup, hubungi majikan Anda untuk meningkatkan keanggotaan.',
  'usage.helperSectionTitle': 'Berikut penggunaan Asisten Rumah Tangga',
  'usage.compareLevels': 'Bandingkan level',
  'usage.upgradeBannerBefore': 'Klik ',
  'usage.upgradeBannerClickHere': 'di sini',
  'usage.upgradeBannerAfter': ' untuk upgrade ke Premium dan membuka kuota serta fitur',
  'usage.upgradeBannerClickAria': 'Buka halaman langganan keanggotaan',
  'usage.playStoreUpgradeNotice':
    'Untuk upgrade atau mengelola langganan, buka layanan ini di browser atau aplikasi Tambahkan ke Layar Utama (aplikasi Google Play tidak menyediakan pembayaran langganan).',
  'membership.restoreModal.title': 'Pulihkan tugas yang diarsipkan',
  'membership.restoreModal.description': 'Keanggotaan Anda telah ditingkatkan. Pilih tugas stok rumah, antar/jemput, atau pengingat obat untuk dipulihkan. Tugas yang tidak dipilih tetap diarsipkan.',
  'membership.restoreModal.confirm': 'Pulihkan yang dipilih',
  'membership.restoreModal.skip': 'Nanti saja',
  'membership.restoreModal.success': 'Tugas terpilih telah dipulihkan',
  'membership.restoreModal.error': 'Tidak dapat memulihkan tugas. Silakan coba lagi.',
  'membership.pricing.compareTitle': 'Bandingkan level keanggotaan',
  'membership.pricing.loading': 'Memuat paket keanggotaan…',
  'membership.pricing.loadError': 'Tidak dapat memuat harga saat ini. Silakan coba lagi nanti.',
  'membership.pricing.priceUnavailable': '—',
  'membership.pricing.monthlyFeeLabel': 'Bulanan:',
  'membership.pricing.yearlyFeeLabel': 'Tahunan:',
  'membership.pricing.cheaperBadge': 'Paket tahunan lebih murah',
  'membership.pricing.discountUntil': 'Diskon hingga {date}',
  'membership.pricing.welcomeRemark': 'Bulan pertama {first}, lalu {thereafter}',
  'membership.pricing.trialStartsOnRegister': 'Uji coba dimulai setelah pendaftaran',
  'membership.pricing.yes': 'Ya',
  'membership.pricing.no': 'Tidak',
  'subscription.openPage': 'Langganan keanggotaan',
  'subscription.title': 'Langganan keanggotaan',
  'subscription.membershipLevel': 'Level keanggotaan',
  'subscription.previousSubscriptionTitle': 'Langganan premium sebelumnya',
  'subscription.previousSubscriptionEnded': 'Langganan premium Anda sebelumnya telah berakhir',
  'subscription.previousSubscriptionPaymentFailed':
    'Langganan premium Anda sebelumnya telah berakhir (pernah gagal bayar)',
  'subscription.trialEndsAt': 'Masa anggota percobaan berakhir',
  'subscription.invitationTrialEndsAt': 'Masa percobaan keanggotaan premium kode undangan berakhir',
  'subscription.subscriptionEndsAt': 'Langganan berakhir',
  'subscription.nextChargeAt': 'Pembayaran berikutnya',
  'subscription.payToday': 'Jadi anggota premium sekarang untuk membuka lebih banyak fitur',
  'subscription.startTrial': 'Atur langganan (belum ditagih selama masa percobaan)',
  'subscription.payTodayAmount': 'Hanya {{amount}} {{period}}',
  'subscription.noChargeToday': 'Tidak ada pembayaran hari ini',
  'subscription.promoPriceFirstMonth': 'Bulan pertama {{dueAmount}}, lalu {{listPrice}} {{period}}',
  'subscription.promoPriceLimitedTime':
    '{{dueAmount}} {{period}} selama promo (hingga {{endsAt}}), lalu {{listPrice}} {{period}}',
  'subscription.promoAppliedFirstMonth': 'Promo bulan pertama: potongan {{amount}}',
  'subscription.promoAppliedLimitedTime':
    'Promo terbatas waktu: potongan {{amount}} (hingga {{endsAt}})',
  'subscription.firstChargeAmount': 'Tagihan pertama {{amount}}',
  'subscription.coversPeriod': 'Periode berbayar pertama: {{start}} hingga {{end}}',
  'subscription.nextCharge': 'Pembayaran berikutnya: {{date}}',
  'subscription.firstChargeOn': 'Tagihan pertama pada {{date}}',
  'subscription.invitationTrialNote':
    'Masa percobaan kode undangan hingga {{date}}; tidak perlu bayar tambahan selama percobaan.',
  'subscription.invitationTrialChargeLaterNote':
    'Masa percobaan kode undangan hingga {{date}}; tagihan pertama akan dimulai pada tanggal akhir masa percobaan.',
  'subscription.subscribeButton': 'Bayar & berlangganan',
  'subscription.resubscribeButton': 'Berlangganan ulang premium',
  'subscription.startTrialButton': 'Atur langganan',
  'subscription.stripeCheckoutDiscountHiddenNote':
    'Halaman pembayaran berikutnya hanya menampilkan tidak ada tagihan hari ini dan harga normal. Diskon tidak dapat ditampilkan di sana. Diskon akan diterapkan otomatis pada tagihan pertama.',
  'subscription.promoMayExpireIfDeferred':
    'Promo terbatas waktu mungkin berakhir sebelum tagihan pertama, sehingga harga normal mungkin dikenakan.',
  'subscription.termsTitle': 'Syarat dan Ketentuan Berlangganan',
  'subscription.termsLinkLabel': 'Syarat dan Ketentuan Berlangganan',
  'subscription.termsConsentPay':
    'Dengan memilih “{{buttonLabel}}” dan membayar, Anda menyetujui {{termsLink}}.',
  'subscription.termsConsentSetup':
    'Dengan memilih “{{buttonLabel}}”, Anda menyetujui {{termsLink}}.',
  'subscription.termsLoadError': 'Tidak dapat memuat syarat berlangganan. Silakan coba lagi.',
  'subscription.alreadySubscribed': 'Anda sudah memiliki langganan berbayar yang aktif.',
  'subscription.stripeNotConfigured': 'Langganan belum diaktifkan di lingkungan ini.',
  'subscription.loadError': 'Tidak dapat memuat detail langganan. Silakan coba lagi.',
  'subscription.checkoutSuccess': 'Langganan berhasil disiapkan.',
  'subscription.checkoutCancel': 'Pembayaran dibatalkan.',
  'subscription.manageButton': 'Kelola langganan',
  'subscription.playStoreBillingNotice':
    'Aplikasi Google Play tidak menyediakan berlangganan, kelola langganan, atau ubah paket.',
  'subscription.playStoreOfficialWebsiteLine':
    'Silakan gunakan browser untuk mengakses situs resmi MaidEasy\n{{url}}',
  'subscription.invoicesTitle': 'Faktur terbaru',
  'subscription.viewInvoiceButton': 'Lihat faktur',
  'subscription.statusActive': 'Status langganan: aktif',
  'subscription.statusPastDue': 'Status langganan: pembayaran gagal',
  'subscription.statusCanceled': 'Status langganan: dibatalkan',
  'subscription.willAutoRenewOn': 'Langganan Anda akan diperpanjang otomatis pada {{date}}',
  'subscription.willAutoRenewOnWithAmount':
    'Langganan Anda akan diperpanjang otomatis pada {{date}} ({{amount}})',
  'subscription.willAutoRenewOnPromo':
    'Langganan Anda akan diperpanjang otomatis pada {{date}} (harga promo {{amount}})',
  'subscription.nextRenewLimitedTimePromo':
    'Promo terbatas waktu: {{dueAmount}} {{period}} (hingga {{endsAt}}, harga normal {{listPrice}})',
  'subscription.periodPerMonth': 'per bulan',
  'subscription.periodPerYear': 'per tahun',
  'subscription.willEndOnCancelled': 'Langganan Anda akan berakhir pada {{date}} (langganan dibatalkan)',
  'subscription.intervalMonth': 'Bulanan',
  'subscription.intervalYear': 'Tahunan',
  'subscription.selectBillingInterval': 'Pilih interval penagihan',
  'subscription.planUnavailable': 'Interval penagihan ini belum tersedia.',
  'subscription.currentBillingInterval': 'Paket saat ini: {{interval}}',
  'subscription.pendingIntervalChange':
    'Dijadwalkan beralih ke {{interval}} pada {{date}} (berlaku setelah periode saat ini)',
  'subscription.lockedPromoReserved':
    'Diskon {{amount}} dicadangkan untuk Anda (penawaran lebih baik pada tanggal penagihan akan digunakan otomatis)',
  'subscription.cancelIntervalChange': 'Batalkan jadwal peralihan',
  'subscription.switchToYear': 'Beralih ke tahunan (periode berikutnya)',
  'subscription.switchToMonth': 'Beralih ke bulanan (periode berikutnya)',
  'subscription.intervalChangeNote':
    'Peralihan berlaku setelah paket saat ini berakhir.',
  'subscription.intervalChangeScheduled': 'Peralihan interval penagihan dijadwalkan.',
  'subscription.intervalChangeCancelled': 'Jadwal peralihan dibatalkan.',
  'subscription.intervalChangeConfirmTitleYear': 'Konfirmasi beralih ke tahunan',
  'subscription.intervalChangeConfirmTitleMonth': 'Konfirmasi beralih ke bulanan',
  'subscription.intervalChangeConfirmIntro':
    'Paket Anda saat ini {{current}}. Peralihan ke {{target}} berlaku setelah paket saat ini berakhir.',
  'subscription.intervalChangeConfirmEffectiveAt': 'Berlaku / paket saat ini berakhir',
  'subscription.intervalChangeConfirmFirstChargeAt': 'Penagihan pertama paket baru',
  'subscription.intervalChangeConfirmCoversPeriod': 'Periode cakupan paket baru pertama',
  'subscription.intervalChangeConfirmCoversPeriodValue': '{{start}} hingga {{end}}',
  'subscription.intervalChangeConfirmAmount': 'Perkiraan jumlah penagihan pertama',
  'subscription.intervalChangeConfirmPromoLimited':
    'Diskon terbatas saat ini: potongan {{amount}} (hingga {{endsAt}}; penawaran lebih baik pada tanggal penagihan akan digunakan otomatis)',
  'subscription.intervalChangeConfirmPromoGeneric': 'Diskon saat ini: potongan {{amount}}',
  'subscription.intervalChangeConfirmNotes': 'Catatan',
  'subscription.intervalChangeConfirmNoRefund':
    'Paket saat ini tetap aktif hingga berakhir.',
  'subscription.intervalChangeConfirmPromoLockNote':
    'Setelah konfirmasi, penawaran terbatas hari ini dicadangkan. Jika ada penawaran lebih baik pada tanggal penagihan, diskon yang lebih tinggi digunakan; jika tidak, penawaran yang dicadangkan tetap dipakai.',
  'subscription.intervalChangeConfirmButtonYear': 'Konfirmasi beralih ke tahunan',
  'subscription.intervalChangeConfirmButtonMonth': 'Konfirmasi beralih ke bulanan',
  'subscription.cancelIntervalChangeConfirmTitle': 'Konfirmasi batalkan jadwal peralihan',
  'subscription.cancelIntervalChangeConfirmIntro':
    'Ini akan membatalkan peralihan ke {{interval}} yang dijadwalkan pada {{date}}. Anda tetap pada paket saat ini.',
  'subscription.cancelIntervalChangeConfirmPromoNote':
    'Diskon yang dicadangkan sebesar {{amount}} juga akan dihapus.',
  'subscription.cancelIntervalChangeConfirmButton': 'Konfirmasi batalkan',
  'membership.restoreTask.action': 'Pulihkan tugas',
  'membership.restoreTask.success': 'Tugas dipulihkan',
  'admin.upgradeToL3': 'Tingkatkan ke L3 (uji)',
  'admin.upgradeToL3Confirm': 'Tingkatkan pemberi kerja ini ke L3? Preferensi terjemahan otomatis akan dipulihkan dan prompt pemulihan akan muncul saat kunjungan dashboard berikutnya.',
  'admin.upgradeToL3Success': 'Berhasil ditingkatkan ke L3.',
  'admin.upgradeToL3Error': 'Gagal meningkatkan ke L3.',
  'admin.grantL3TrialTitle': 'Berikan trial L3',
  'admin.grantL3TrialHint': 'Masukkan tanggal dan waktu berakhir. Sistem akan mempertahankan pemberi kerja di L3 dan menyimpannya sebagai akhir trial L3 kode undangan.',
  'admin.grantL3TrialField': 'Trial berakhir pada (waktu lokal)',
  'admin.grantL3TrialButton': 'Berikan trial L3',
  'admin.grantL3TrialConfirm': 'Berikan trial L3 kepada pemberi kerja ini?',
  'admin.grantL3TrialSuccess': 'Trial L3 berhasil diberikan.',
  'admin.grantL3TrialError': 'Gagal memberikan trial L3.',
  'admin.grantL3TrialDateRequired': 'Masukkan tanggal dan waktu akhir trial terlebih dahulu.',
  'limitModal.title.default': 'Batas penggunaan tercapai',
  'limitModal.title.batchInsufficient': 'Kuota harian tidak mencukupi',
  'limitModal.title.TOTAL_TASK_LIMIT_REACHED': 'Batas pembuatan tugas tercapai',
  'limitModal.title.COMMENT_LIMIT_REACHED': 'Batas komentar tercapai',
  'limitModal.title.DAILY_TASK_SUBMIT_LIMIT_REACHED': 'Batas kirim tugas harian tercapai',
  'limitModal.title.DAILY_TASK_REVIEW_LIMIT_REACHED': 'Batas tinjau tugas harian tercapai',
  'limitModal.title.DAILY_RECEIPT_LIMIT_REACHED': 'Batas resi harian tercapai',
  'limitModal.title.DAILY_AI_ANALYZE_LIMIT_REACHED': 'Batas analisis AI harian tercapai',
  'limitModal.title.TASK_KIND_NOT_ALLOWED': 'Jenis tugas tidak tersedia',
  'limitModal.title.AUTO_TRANSLATION_NOT_ALLOWED': 'Terjemahan otomatis tidak tersedia',
  'limitModal.title.INVENTORY_LOCATION_LIMIT_REACHED': 'Batas lokasi inventaris tercapai',
  'limitModal.title.INVENTORY_CATEGORY_LIMIT_REACHED': 'Batas kategori inventaris tercapai',
  'limitModal.title.PIN_MESSAGE_LIMIT_REACHED': 'Batas pesan pin tercapai',
  'limitModal.body.TOTAL_TASK_LIMIT_REACHED': 'Anda telah membuat {{total}}/{{max}} tugas (tugas diarsipkan tidak dihitung).',
  'limitModal.body.COMMENT_LIMIT_REACHED': 'Komentar untuk item ini sudah mencapai {{total}}/{{max}}.',
  'limitModal.body.DAILY_TASK_SUBMIT_LIMIT_REACHED': 'Terkirim {{used}}/{{limit}} hari ini. Reset berikutnya: {{retryAt}}.',
  'limitModal.body.DAILY_TASK_REVIEW_LIMIT_REACHED': 'Ditinjau {{used}}/{{limit}} hari ini. Reset berikutnya: {{retryAt}}.',
  'limitModal.body.DAILY_RECEIPT_LIMIT_REACHED': 'Terkirim {{used}}/{{limit}} resi hari ini. Reset berikutnya: {{retryAt}}.',
  'limitModal.body.DAILY_AI_ANALYZE_LIMIT_REACHED': 'Digunakan {{used}}/{{limit}} analisis AI hari ini. Reset berikutnya: {{retryAt}}.',
  'limitModal.body.batchInsufficient.DAILY_RECEIPT_LIMIT_REACHED':
    'Sisa pengiriman resi hari ini {{remaining}} kali ({{used}}/{{limit}} terpakai), tidak cukup untuk mengirim {{requested}} resi. Reset berikutnya: {{retryAt}}.',
  'limitModal.body.batchInsufficient.DAILY_AI_ANALYZE_RECEIPT':
    'Sisa analisis AI hari ini {{remaining}} kali ({{used}}/{{limit}} terpakai), tidak cukup untuk menganalisis {{requested}} resi. Reset berikutnya: {{retryAt}}.',
  'limitModal.body.batchInsufficient.DAILY_AI_ANALYZE_PHOTO':
    'Sisa analisis AI hari ini {{remaining}} kali ({{used}}/{{limit}} terpakai), tidak cukup untuk menganalisis {{requested}} foto. Reset berikutnya: {{retryAt}}.',
  'limitModal.body.TASK_KIND_NOT_ALLOWED': 'Level keanggotaan Anda tidak mendukung jenis tugas ini.',
  'limitModal.body.AUTO_TRANSLATION_NOT_ALLOWED': 'Level keanggotaan Anda tidak mendukung terjemahan otomatis.',
  'limitModal.body.INVENTORY_LOCATION_LIMIT_REACHED': 'Jumlah lokasi inventaris telah mencapai batas keanggotaan.',
  'limitModal.body.INVENTORY_CATEGORY_LIMIT_REACHED': 'Jumlah kategori inventaris telah mencapai batas keanggotaan.',
  'limitModal.body.PIN_MESSAGE_LIMIT_REACHED': 'Anda telah membuat {{total}}/{{max}} pesan pin.',
  'limitModal.title.PIN_MESSAGE_ACTIVE_LIMIT_REACHED': 'Batas pesan pin aktif tercapai',
  'limitModal.body.PIN_MESSAGE_ACTIVE_LIMIT_REACHED':
    'Total pesan pin melebihi batas keanggotaan gratis. Maksimal {{max}} pesan aktif sekaligus (saat ini {{total}} aktif). Nonaktifkan pesan lain atau upgrade keanggotaan.',
  'limitModal.body.default': 'Akun Anda telah mencapai batas untuk level keanggotaan saat ini.',
  'limitModal.helperHint': 'Hubungi majikan Anda untuk meningkatkan keanggotaan demi kuota lebih tinggi.',
  'limitModal.employerDailyHint': 'Lihat halaman penggunaan untuk detail; upgrade meningkatkan kuota harian.',
  'limitModal.employerTotalTasksHint': 'Anda dapat upgrade untuk membuat lebih banyak tugas.',
  'limitModal.employerTaskKindHint': 'Silakan upgrade keanggotaan untuk menggunakan jenis tugas ini.',
  'limitModal.employerPinMessagesHint': 'Anda dapat upgrade untuk menambahkan lebih banyak pesan pin.',
  'limitModal.employerL3Hint':
    'Anda telah mencapai batas paket saat ini. Anda dapat melihat detail di halaman penggunaan.',
  'limitModal.close': 'Tutup',
  'limitModal.viewUsage': 'Lihat detail penggunaan',
  'limitModal.goSubscription': 'Buka langganan / upgrade',
  'limitModal.playStoreBillingHint':
    'Aplikasi Google Play tidak dapat memproses upgrade di sini. Kelola langganan di browser atau aplikasi Tambahkan ke Layar Utama.',
  'settings.notifyEmailLabel': 'Kirim juga pemberitahuan aktivitas melalui email',
  'settings.autoTranslationLabel': 'Terjemahkan otomatis teks yang dimasukkan pihak lain',
  'settings.autoTranslationHint':
    'Jika dimatikan, komentar, deskripsi tugas, dll. hanya menampilkan teks asli dan layanan terjemahan tidak dipanggil.',
  'settings.notifyWebPushLabel': 'Terima pemberitahuan di perangkat ini (Web Push)',
  'settings.webPushToggleError': 'Tidak dapat memperbarui setelan notifikasi',
  'settings.notifyWebPushPermissionDeniedHint': 'Izin pemberitahuan browser diblokir. Harap izinkan pemberitahuan di pengaturan situs browser, lalu segarkan halaman ini.',
  'settings.webPushPromptTitle': 'Aktifkan pemberitahuan push',
  'settings.webPushPromptBody': 'Izinkan notifikasi untuk menerima pembaruan tugas dan ulasan secara real time.',
  'settings.webPushPromptEnable': 'Izinkan notifikasi',
  'settings.androidChromePushHintTitle': 'Push sistem memerlukan Chrome',
  'settings.androidChromePushHintBody':
    'Browser di perangkat ini tidak mendukung Web Push dengan baik. Instal atau perbarui Chrome terbaru untuk menerima pemberitahuan tugas dan ulasan secara real time. Notifikasi lonceng dalam aplikasi tetap berfungsi.',
  'settings.androidChromePushHintCta': 'Instal / perbarui Chrome',
  'settings.androidChromePushHintDismiss': 'Nanti saja',
  'settings.save': 'Simpan pengaturan',
  'settings.saving': 'Penghematan…',
  'settings.saved': 'Disimpan',
  'settings.invitationCodeTitle': 'Tukar kode undangan',
  'settings.invitationCodeSubscriptionTitle': 'Punya kode undangan?',
  'settings.invitationCodeHint': 'Masukkan kode 8 karakter untuk memperpanjang uji coba atau naik ke uji coba anggota berbayar.',
  'settings.invitationCodeInputLabel': 'Kode undangan',
  'settings.invitationCodeInputPlaceholder': 'Masukkan kode 8 karakter',
  'settings.invitationCodeRedeemButton': 'Tukar',
  'settings.invitationCodeRedeemSuccess': 'Kode undangan berhasil ditukar',
  'settings.invitationCodeRedeemFailed': 'Gagal menukar kode undangan. Coba lagi.',
  'settings.invitationCodeInvalid': 'Kode undangan tidak valid',
  'settings.invitationCodeErrorRegistrationOnly':
    'Kode undangan ini hanya bisa digunakan saat pendaftaran',
  'settings.invitationCodeErrorNotL1Trial': 'Kode ini hanya berlaku saat uji coba',
  'settings.invitationCodeErrorL1TrialEnded': 'Uji coba Anda sudah berakhir',
  'settings.invitationCodeErrorSubscriptionActive': 'Anda sudah memiliki langganan berbayar aktif',
  'settings.invitationCodeErrorEmailAlreadyUsed': 'Anda sudah menggunakan kode undangan ini',
  'settings.invitationCodePreviewL1Extend': 'Perpanjang uji coba {{days}} hari. Berakhir: {{endsAt}}',
  'settings.invitationCodePreviewL3Trial': 'Naik ke uji coba anggota berbayar {{days}} hari. Berakhir: {{endsAt}}',
  'settings.invitationCodePreviewL3SubscriptionExtend': 'Perpanjang langganan {{days}} hari. Berakhir: {{endsAt}}',
  'settings.loadError': 'Tidak dapat memuat pengaturan',
  'settings.saveError': 'Gagal menyimpan',
  'settings.logout': 'Keluar',
  'settings.logoutConfirmTitle': 'Keluar?',
  'settings.logoutConfirmDescription': 'Anda harus masuk lagi untuk menggunakan akun Anda.',
  'settings.changePassword': 'Ubah kata sandi',
  'settings.changePasswordHint': 'Ubah kata sandi di sini saat masuk.',
  'settings.googlePasswordManagedHint': 'Akun ini menggunakan login Google dan tidak mendukung perubahan atau penyetelan ulang sandi.',
  'settings.currentPasswordLabel': 'Kata sandi saat ini',
  'settings.newPasswordLabel': 'Kata sandi baru',
  'settings.confirmNewPasswordLabel': 'Konfirmasikan kata sandi baru',
  'settings.changePasswordSubmit': 'Perbarui kata sandi',
  'settings.changePasswordSaving': 'Memperbarui…',
  'settings.changePasswordSuccess': 'Kata sandi diperbarui. Silakan masuk lagi.',
  'settings.changePasswordError': 'Tidak dapat mengubah kata sandi',
  'settings.changePasswordCurrentPasswordIncorrect': 'Kata sandi saat ini salah. Silakan coba lagi.',
  'settings.expandChangePasswordSectionAria': 'Luaskan bagian ubah kata sandi',
  'settings.collapseChangePasswordSectionAria': 'Ciutkan bagian ubah kata sandi',
  'settings.expandAccountRemovalSectionAria': 'Luaskan bagian hapus akun',
  'settings.collapseAccountRemovalSectionAria': 'Ciutkan bagian hapus akun',
  'settings.resendVerification': 'Kirim ulang email verifikasi',
  'settings.resendVerificationSending': 'Mengirim…',
  'settings.resendVerificationSuccess': 'Email verifikasi terkirim. Periksa kotak masuk Anda.',
  'settings.resendVerificationError': 'Pengiriman gagal',
  'settings.resendVerificationCooldown': 'Harap tunggu 15 menit sebelum meminta email verifikasi lainnya.',
  'settings.emailUnverifiedBanner': 'Email Anda belum diverifikasi. Anda tidak akan dapat menggunakan fitur aplikasi ini.',
  'settings.accountRemovalPasswordLabel': 'Masukkan kata sandi Anda untuk mengonfirmasi',
  'settings.accountRemovalGoogleHint': 'Setelah dikirim, email konfirmasi akan dikirim. Buka tautan dalam 30 menit, lalu tekan konfirmasi di halaman. Akun langsung dihapus setelah konfirmasi.',
  'settings.backToPairingStatus': 'Kembali ke status berpasangan',
  'settings.mainMenuAria': 'Menu utama',
  'settings.menuHome': 'Beranda',
  'settings.menuTasksEmployer': 'Tugas',
  'settings.menuTasksHelper': 'Daftar tugas',
  'settings.menuSettlements': 'Biaya & penyelesaian',
  'settings.menuMoneyGiven': 'Uang Diberikan',
  'settings.menuSettlementRecords': 'Catatan penyelesaian',
  'settings.menuPinMessages': 'Sematkan pengaturan pesan',
  'settings.menuBudgets': 'Pengelolaan Uang Diberikan',
  'settings.menuReceipts': 'Pindai Tanda Terima',
  'settings.menuReceiptBrowse': 'Daftar tanda terima',
  'settings.menuFamily': 'Preferensi Anggota Keluarga',
  'settings.menuPairingStatus': 'Status berpasangan',
  'settings.menuConfirmSettlement': 'Konfirmasikan penyelesaian',
  'settings.menuSettings': 'Pengaturan',
  'settings.menuOverview': 'Ringkasan',
  'settings.menuAccountSettings': 'Pengaturan akun',
  'settings.menuSubscriptionAndInvite': 'Langganan & tukar kode undangan',
  'settings.menuMoneyGivenSettlement': 'Pemberian Uang & Penyelesaian',
  'settings.menuTodayTask': 'Tugas hari ini',
  'settings.menuImportPreviousPairing': 'Import from previous pairing',
  'pairing.import.title': 'Import from previous pairing',
  'pairing.import.description':
    'Copy tasks, family members, and pin messages from your most recent ended pairing into the current one. Nothing is selected by default — tick the items you want.',
  'pairing.import.later': 'Later',
  'pairing.import.import': 'Import',
  'pairing.import.sectionTasks': 'Tasks',
  'pairing.import.sectionFamily': 'Family members',
  'pairing.import.sectionPins': 'Pin messages',
  'pairing.import.alreadyImported': 'Already imported',
  'pairing.import.consentLabel':
    'I confirm importing the selected family members and that their existing consent flags apply.',
  'pairing.import.empty':
    'Nothing to import (items may already be imported, or the previous pairing had no data).',
  'pairing.import.success': 'Selected items were imported',
  'pairing.import.error': 'Could not import. Please try again.',
  'pairing.import.loadError': 'Could not load import options. Please try again.',
  'pairing.import.taskQuotaHint': 'Task slots: {{used}}/{{max}} (archived tasks not counted)',
  'pairing.import.pinQuotaHint': 'Pin messages: {{used}}/{{max}}',
  'pairing.import.taskKindStandard': 'Standard task',
  'previousHelper.detailBanner':
    'Tugas ini ditangani oleh Helper sebelumnya. Helper Anda saat ini tidak dapat melihat catatan ini.',
  'previousHelper.receiptBanner':
    'Tanda terima ini dikirim oleh Helper sebelumnya. Helper Anda saat ini tidak dapat melihat catatan ini.',
  'previousHelper.settlementBanner':
    'Penyelesaian ini dikirim oleh Helper sebelumnya. Helper Anda saat ini tidak dapat melihat catatan ini.',
  'previousHelper.unpairedDetailBanner':
    'Catatan ini milik pemasangan yang sudah berakhir. Helper baru tidak akan melihatnya setelah dipasangkan.',
  'previousHelper.unpairedReceiptBanner':
    'Tanda terima ini milik pemasangan yang sudah berakhir. Helper baru tidak akan melihatnya setelah dipasangkan.',
  'previousHelper.unpairedSettlementBanner':
    'Penyelesaian ini milik pemasangan yang sudah berakhir. Helper baru tidak akan melihatnya setelah dipasangkan.',
  'pairing.unpairedBanner':
    'Anda belum dipasangkan dengan Helper. Anda sudah bisa membuat tugas, pesan sematan, anggota keluarga, dan uang yang diberikan. Helper baru bisa melihatnya setelah dipasangkan.',
  'pairing.unpairedBannerAction': 'Buat kode pemasangan',
  'pairing.unpairedBannerAria': 'Belum dipasangkan',
  'settings.accountRemoval': 'Hapus akun',
  'settings.accountRemovalHint': 'Setelah Anda memasukkan kata sandi dan mengirim, akun langsung dihapus dan tidak dapat dipulihkan.',
  'settings.accountRemovalSubmit': 'Konfirmasi dan hapus akun',
  'settings.accountRemovalSuccess': 'Email konfirmasi telah dikirim. Buka tautan dalam 30 menit, lalu tekan konfirmasi di halaman untuk menghapus akun.',
  'settings.accountRemovalDeleted': 'Akun Anda telah dihapus.',
  'settings.accountRemovalError': 'Permintaan gagal. Silakan coba lagi nanti.',
  'settings.accountRemovalPasswordIncorrect': 'Kata sandi salah. Silakan coba lagi.',
  'settings.closePanel': 'Menutup',
  'toast.offlineQueued': 'Ditambahkan ke antrian offline. Ini akan disinkronkan secara otomatis saat online.',
  'toast.task.createSuccess': 'Tugas berhasil dibuat!',
  'toast.task.updateSuccess': 'Tugas berhasil disimpan!',
  'toast.task.completeSuccess': 'Penyelesaian tugas berhasil dikirimkan!',
  'toast.task.resubmitSuccess': 'Tugas berhasil dikirim ulang!',
  'toast.task.reviewedSuccess': 'Tugas berhasil ditinjau!',
  'toast.task.needUpdateSuccess': 'Tugas yang ditandai sebagai perlu diperbarui berhasil!',
  'toast.receiptAnalyze.singleSavedOnline':
    'Tanda terima disimpan. Langkah berikutnya: kirim penyelesaian ke majikan',
  'toast.receiptAnalyze.singleSavedStillUnsaved':
    'Tanda terima disimpan. Masih ada {{count}} tanda terima belum disimpan — simpan semua dulu.',
  'toast.receiptAnalyze.singleSavedOffline': 'Tanda terima disimpan ke antrian offline.',
  'toast.receiptAnalyze.batchAllOnlineSuccess': 'Batch selesai: {{successCount}} tanda terima berhasil disimpan.',
  'toast.receiptAnalyze.batchAllOfflineQueued': 'Batch selesai: {{queuedCount}} tanda terima ditambahkan ke antrean offline.',
  'toast.receiptAnalyze.batchMixedOnlineOfflineSuccess': 'Batch selesai: {{onlineCount}} disimpan, {{queuedCount}} dimasukkan dalam antrean offline.',
  'toast.receiptAnalyze.batchPartialResult': 'Batch selesai: {{onlineCount}} disimpan, {{queuedCount}} antri offline, {{failedCount}} gagal.',
  'toast.receipt.editSuccess': 'Tanda terima berhasil disimpan!',
  'toast.receipt.deleteSuccess': 'Tanda terima berhasil dihapus!',
  'toast.budget.createSuccess': 'Uang yang Diberikan berhasil dibuat!',
  'toast.budget.updateSuccess': 'Uang yang Diberikan berhasil disimpan!',
  'toast.budget.deleteSuccess': 'Uang yang Diberikan berhasil dihapus!',
  'toast.pinMessage.createSuccess': 'Pesan pin berhasil dibuat!',
  'toast.pinMessage.updateSuccess': 'Pesan pin berhasil disimpan!',
  'toast.pinMessage.deleteSuccess': 'Pesan pin berhasil dihapus!',
  'toast.familyMember.createSuccess': 'Anggota keluarga berhasil ditambahkan!',
  'toast.familyMember.updateSuccess': 'Anggota keluarga berhasil diperbarui!',
  'toast.familyMember.deleteSuccess': 'Anggota keluarga berhasil dihapus!',
  'toast.settings.updateSuccess': 'Pengaturan berhasil disimpan!',
  'toast.settings.changePasswordSuccess': 'Kata sandi berhasil diubah!',
  'toast.pairing.joinSuccess': 'Penyandingan berhasil diselesaikan!',
  'toast.pairing.unpairSuccess': 'Penyandingan berhasil dihapus!',
  'toast.pairing.generateCodeSuccess': 'Kode penyandingan berhasil dibuat!',
  'toast.consent.acceptSuccess': 'Persetujuan berhasil dikirimkan!',
  'toast.settlement.confirmSuccess': 'Penyelesaian berhasil dikirimkan!',
  'toast.settlement.unlockSuccess': 'Penyelesaian berhasil dibuka!',
  'toast.settlement.withdrawSuccess': 'Penyelesaian berhasil ditarik!',
  'toast.settlement.reviewedSuccess': 'Penyelesaian berhasil ditinjau!',
  'toast.settlement.rejectedSuccess': 'Penyelesaian berhasil ditolak!',
  'toast.settlement.withdrawConfirmTitle': 'Tarik penyelesaian ini?',
  'toast.settlement.withdrawConfirmBody': 'Setelah penarikan, penyelesaian ini akan ditandai sebagai penarikan. Melanjutkan?',
  'pairing.generate.title': 'Hasilkan kode penyandingan',
  'pairing.generate.subtitle': 'Hasilkan kode untuk dibagikan dengan pembantu Anda untuk dipasangkan',
  'pairing.generate.errorGeneric': 'Gagal membuat kode penyandingan',
  'pairing.generate.codeLabel': 'Kode penyandingan Anda',
  'pairing.generate.validUntil': 'Berlaku hingga {{datetime}} ({{duration}})',
  'pairing.generate.durationMinutes': '{{count}} menit',
  'pairing.generate.durationHours': '{{count}} jam',
  'pairing.generate.durationDay': '{{count}} hari',
  'pairing.generate.durationDays': '{{count}} hari',
  'pairing.generate.copyAria': 'Salin kode penyandingan ke papan klip',
  'pairing.generate.copied': 'Disalin!',
  'pairing.generate.copyCode': 'Salin kode',
  'pairing.generate.regenerate': 'Diperbarui',
  'pairing.generate.regenerating': 'Menghasilkan…',
  'pairing.generate.regenerateAria': 'Buat ulang kode penyandingan',
  'pairing.generate.continue': 'Melanjutkan',
  'pairing.generate.continueAria': 'Lanjutkan ke langkah berikutnya',
  'pairing.generate.generateCta': 'Hasilkan kode penyandingan',
  'pairing.generate.generateAria': 'Hasilkan kode penyandingan',
  'pairing.generate.footer': 'Bagikan tautan pendaftaran atau kode QR ini dengan pembantu Anda. Mereka akan berpasangan dengan Anda secara otomatis saat mereka mendaftar.',
  'pairing.generate.qrAria': 'Tautan pendaftaran pembantu kode QR',
  'pairing.generate.shareLabel': 'Bagikan',
  'pairing.generate.shareAria': 'Bagikan kode QR dan tautan pendaftaran',
  'pairing.generate.shareInviteTitle': 'Undangan MaidEasy',
  'pairing.generate.shareInviteText':
    'Majikan {{nickname}} mengundang Anda menggunakan MaidEasy. Ketuk tautan atau pindai kode QR untuk mendaftar.',
  'pairing.generate.shareEmployerFallback': 'Majikan',
  'pairing.generate.shareError': 'Tidak dapat membagikan. Silakan coba lagi.',
  'pairing.join.title': 'Masukkan kode penyandingan',
  'pairing.join.subtitle': 'Masukkan kode 6 karakter dari perusahaan Anda untuk dipasangkan',
  'pairing.join.errorIncomplete': 'Silakan masukkan kode karakter {{length}} lengkap',
  'pairing.join.errorGeneric': 'Penyandingan gagal',
  'pairing.join.pairing': 'Memasangkan…',
  'pairing.join.submit': 'Kirimkan kode',
  'pairing.join.submitAria': 'Kirimkan kode penyandingan',
  'pairing.join.inputGroupAria': 'Memasangkan masukan kode',
  'pairing.join.charAria': 'Karakter kode {{n}}',
  'pairing.join.footer': 'Tanyakan kode pasangan kepada majikan Anda. Kode ini berlaku selama {{duration}}.',
  'pairing.invite.landingTitle': 'Anda akan memasangkan dengan {{nickname}}',
  'pairing.invite.landingSubtitle': 'Masuk atau daftar untuk menyelesaikan pemasangan',
  'pairing.invite.emailLogin': 'Masuk dengan email',
  'pairing.invite.googleLogin': 'Masuk dengan Google',
  'pairing.invite.register': 'Daftar',
  'pairing.invite.invalidTitle': 'Tautan penyandingan tidak valid',
  'pairing.invite.errorInvalid': 'Tautan penyandingan ini tidak valid atau telah habis masa berlakunya. Mintalah tautan baru kepada majikan Anda.',
  'pairing.invite.errorFormat': 'Format kode penyandingan tidak valid.',
  'pairing.invite.previewError': 'Tidak dapat memverifikasi kode penyandingan. Silakan coba lagi nanti.',
  'pairing.invite.loginBanner': 'Setelah masuk, Anda akan memasangkan dengan {{nickname}} secara otomatis',
  'pairing.invite.registerBanner': 'Daftar sebagai Pembantu dan pasangkan dengan {{nickname}}',
  'pairing.invite.confirmTitle': 'Sandingkan dengan {{nickname}}',
  'pairing.invite.confirmSubtitle': 'Pemasangan akan selesai segera setelah Anda mengonfirmasi',
  'pairing.invite.confirmCta': 'Konfirmasikan penyandingan',
  'pairing.invite.confirmDialogTitle': 'Sandingkan dengan {{nickname}}?',
  'pairing.invite.confirmDialogDescription': 'Setelah memasangkan, Anda dapat mulai menggunakan MaidEasy.',
  'pairing.invite.employerSignedIn': 'Tautan ini untuk Pembantu. Anda masuk sebagai perusahaan.',
  'pairing.invite.helperAlreadyPaired': 'Anda sudah berpasangan. Tautan ini tidak diperlukan.',
  'pairing.invite.goPairingStatus': 'Buka status berpasangan',
  'pairing.invite.expiredTitle': 'Tautan penyandingan telah habis masa berlakunya',
  'pairing.invite.expiredBody': 'Kode penyandingan mungkin sudah habis masa berlakunya atau sudah digunakan.',
  'pairing.invite.contactEmployer': 'Kode penyandingan tidak valid. Silakan hubungi majikan Anda.',
  'pairing.generate.copyInviteLink': 'Salin link registrasi dengan kode pairing',
  'pairing.generate.copyInviteLinkAria': 'Salin tautan pendaftaran Pembantu ke papan klip',
  'pairing.status.regenerateCode': 'Hasilkan kode baru',
  'pairing.status.goGenerateNew': 'Hasilkan kode penyandingan baru',
  'auth.googleLoginRequiredTitle': 'Masuk dengan Google',
  'auth.googleLoginRequiredDescription': 'Email ini harus masuk dengan Google. Beralih ke masuk Google?',
  'auth.googleLoginRequiredConfirm': 'Masuk dengan Google',
  'pairing.success.title': 'Penyandingan berhasil!',
  'pairing.success.subtitle': 'Anda telah berhasil dipasangkan',
  'pairing.success.pairedWith': 'Dipasangkan dengan',
  'pairing.success.nextTitle': 'Berikutnya: Perjanjian persetujuan',
  'pairing.success.nextBody': 'Anda perlu meninjau dan menerima perjanjian persetujuan dan Pernyataan Pengumpulan Informasi Pribadi (PICS) sebelum Anda dapat mulai menggunakan aplikasi.',
  'pairing.success.continue': 'Lanjutkan untuk menyetujui',
  'pairing.success.continueAria': 'Lanjutkan untuk menyetujui perjanjian',
  'pairing.success.nextTitleReady': 'Berikutnya: Mulai menggunakan aplikasi',
  'pairing.success.nextBodyReady': 'Anda telah menerima Pernyataan Pengumpulan Informasi Pribadi (PICS) saat pendaftaran. Anda dapat masuk ke aplikasi.',
  'pairing.success.continueApp': 'Buka aplikasi',
  'pairing.success.continueAppAria': 'Buka beranda aplikasi',
  'role.employer': 'Pemberi pekerjaan',
  'role.helper': 'Pembantu',
  'pairing.status.loadingAria': 'Memuat status penyandingan',
  'pairing.status.errorGeneric': 'Gagal mengambil status penyandingan',
  'pairing.status.activeTitle': 'Pasangan aktif',
  'pairing.status.yourPartner': 'Pasanganmu',
  'pairing.status.pairedSince': 'Dipasangkan sejak {{datetime}}',
  'pairing.status.notPairedTitle': 'Belum dipasangkan',
  'pairing.status.emailUnverifiedHint': 'Email Anda belum diverifikasi. Verifikasi dulu sebelum memakai aplikasi.',
  'pairing.status.consentRequiredHint': 'Anda belum menyetujui ketentuan. Setujui dulu sebelum memakai aplikasi.',
  'pairing.status.notPairedEmployer': 'Hasilkan kode penyandingan untuk dibagikan dengan pembantu Anda',
  'pairing.status.notPairedHelper': 'Masukkan kode penyandingan dari perusahaan Anda',
  'pairing.status.goGenerate': 'Hasilkan kode penyandingan',
  'pairing.status.goEnter': 'Masukkan kode penyandingan',
  'pairing.status.generateAria': 'Hasilkan kode penyandingan',
  'pairing.status.enterAria': 'Masukkan kode penyandingan',
  'pairing.status.unpairButton': 'Putuskan pasangan',
  'pairing.status.unpairAria': 'Putuskan pasangan saat ini',
  'pairing.status.unpairing': 'Melepaskan pasangan…',
  'pairing.status.unpairConfirm': 'Apakah Anda yakin ingin melepaskan pemasangan saat ini? Anda perlu memasangkan lagi setelahnya.',
  'pairing.status.unpairError': 'Gagal melepaskan pasangan. Silakan coba lagi nanti.',
  'protected.loadingAria': 'Memuat',
  'app.autoUpdatingTitle': 'Memperbarui aplikasi secara otomatis...',
  'app.autoUpdatingSlowHint': 'Pembaruan tampaknya lebih lambat dari yang diharapkan. Harap tunggu...',
  'app.autoUpdatingVersionLine': 'Saat ini: {{currentVer}} | Baru: {{newVer}}',
  'task.status.pending': 'Tertunda',
  'task.status.notSubmitted': 'Tidak diserahkan',
  'task.status.approved': 'Disetujui',
  'task.status.rejected': 'Ditolak',
  'task.status.needsUpdate': 'Perlu Pembaruan',
  'task.status.cancel': 'Dibatalkan',
  'receipt.status.save': 'Belum diselesaikan',
  'receipt.status.submitted': 'Dikirim',
  'receipt.status.reviewed': 'Ditinjau',
  'task.recurrence.none': 'Sekali',
  'task.recurrence.daily': 'Sehari-hari',
  'task.recurrence.weekly': 'Mingguan',
  'task.recurrence.biweekly': 'Dua kali seminggu',
  'task.recurrence.monthly': 'Bulanan',
  'task.monthlyKind.day': 'Berdasarkan tanggal (tanggal X setiap bulan)',
  'task.monthlyKind.nthWeekday': 'Hari kerja ke-N',
  'task.monthlyKind.lastWeekday': 'Hari kerja terakhir',
  'task.form.monthlyKindLabel': 'Aturan bulanan',
  'task.form.monthDaysLabel': 'Tanggal dalam bulan',
  'task.form.monthlyOrdinalLabel': 'Kejadian ke',
  'task.form.monthlyOrdinal.1': 'Ke-1',
  'task.form.monthlyOrdinal.2': 'Ke-2',
  'task.form.monthlyOrdinal.3': 'Ke-3',
  'task.form.monthlyOrdinal.4': 'Ke-4',
  'task.form.monthlyOrdinal.5': 'Ke-5',
  'task.form.monthlyDayClampHint': 'Jika bulan tidak memiliki tanggal yang dipilih (mis. 29–31), tugas jatuh pada hari terakhir bulan itu.',
  'task.form.monthlyFifthWeekdayHint': 'Jika bulan tidak memiliki kejadian ke-5 dari hari yang dipilih, tidak ada tugas pada bulan itu.',
  'task.form.recurrenceMonthDaysRequired': 'Pilih setidaknya satu tanggal dalam bulan.',
  'task.day.sun': 'Matahari',
  'task.day.mon': 'Senin',
  'task.day.tue': 'Selasa',
  'task.day.wed': 'Menikahi',
  'task.day.thu': 'Kam',
  'task.day.fri': 'Jumat',
  'task.day.sat': 'Duduk',
  'task.list.title': 'Manajemen Tugas',
  'task.list.subtitle': 'Kelola tugas untuk pembantu Anda',
  'task.list.tabAll': 'Semua',
  'task.list.tabToday': 'Hari ini',
  'task.list.tabRecurring': 'Berulang',
  'task.list.tabTodayTask': 'Hari ini',
  'task.list.tabEditTask': 'Sunting tugas',
  'task.list.tabOverdueTask': 'Tugas yang terlambat',
  'task.list.tabEffectiveTask': 'Tugas yang Efektif',
  'task.list.tabExpiredTask': 'Tugas Kedaluwarsa',
  'task.list.addNew': 'Tambahkan Tugas',
  'task.list.addChoiceTitle': 'Apa yang harus dibuat',
  'task.list.addChoiceSubtitle': 'Pilih jenis tugas yang ingin Anda buat.',
  'task.list.addChoiceStandard': 'Buat tugas Standar',
  'task.list.addChoiceInventory': 'Buat Stok Rumah',
  'task.list.addChoicePickupDropoff': 'Buat Tugas Penjemputan / Pengantaran',
  'task.list.addChoiceMedication': 'Buat Pengingat Obat',
  'task.list.addChoiceLockedAria': '"{{label}}" memerlukan upgrade keanggotaan',
  'task.list.kindStockTake': 'Stok Rumah',
  'task.list.kindPickupDropoff': 'Angkat / Turunkan',
  'task.list.kindMedication': 'Pengingat Pengobatan',
  'task.pickup.loadError': 'Tidak dapat memuat data tugas pengambilan/pengantaran',
  'task.pickup.createHeading': 'Buat Tugas Penjemputan / Pengantaran',
  'task.pickup.editHeading': 'Edit Tugas Pengambilan / Pengantaran',
  'task.pickup.stepProgress': 'Langkah {{step}} / {{total}}',
  'task.pickup.legHint': 'Pilih apakah akan membuat penjemputan, pengantaran, atau keduanya',
  'task.pickup.pickupLabel': 'Menjemput',
  'task.pickup.dropoffLabel': 'Menurunkan',
  'task.pickup.legRequired': 'Pilih setidaknya Drop off atau Pick up',
  'task.pickup.personLabel': 'Siapa yang harus dijemput/diantar',
  'task.pickup.personPlaceholder': 'misalnya Dave',
  'task.pickup.suggestHeading': 'Saran anggota keluarga',
  'task.pickup.personRequired': 'Silakan masukkan siapa yang akan dijemput/diantar',
  'task.pickup.pickupTimeLabel': 'Waktu penjemputan',
  'task.pickup.dropoffTimeLabel': 'Waktu pengantaran',
  'task.pickup.pickupTimeRequired': 'Diperlukan waktu penjemputan',
  'task.pickup.dropoffTimeRequired': 'Diperlukan waktu pengantaran',
  'task.pickup.timesMustDiffer': 'Waktu pengantaran dan penjemputan harus berbeda',
  'task.pickup.locationLabel': 'Lokasi (opsional)',
  'task.pickup.locationSuggestHeading': 'Saran',
  'task.pickup.locationChip.school': 'Sekolah',
  'task.pickup.locationChip.tutoring': 'Kelas bimbingan belajar',
  'task.pickup.locationChip.stadium': 'Stadion',
  'task.pickup.locationChip.soccerPitch': 'Lapangan sepak bola',
  'task.pickup.locationChip.mall': 'Mall',
  'task.pickup.reviewPickupTitle': 'Ambil judul',
  'task.pickup.reviewDropoffTitle': 'Judul penyerahan',
  'task.pickup.editTitleAria': 'Edit judul tugas',
  'task.pickup.submitCreate': 'Buat Tugas Penjemputan / Pengantaran',
  'task.pickup.customTitleModalTitle': 'Judul khusus',
  'task.pickup.titleChoiceTitle': 'Cara memperbarui judul',
  'task.pickup.titleChoicePickup': 'Menjemput',
  'task.pickup.titleChoiceDropoff': 'Menurunkan',
  'task.pickup.titleChoiceKeep': 'Pertahankan judul aslinya',
  'task.pickup.titleChoiceUseNew': 'Gunakan judul baru',
  'task.pickup.titleChoiceCustom': 'Kebiasaan',
  'task.pickup.createSuccess': 'Tugas Pick up / Drop off dibuat',
  'task.pickup.updateSuccess': 'Tugas Pengambilan / Pengantaran diperbarui',
  'task.pickup.createError': 'Tidak dapat membuat tugas Penjemputan/Pengantaran',
  'task.medication.loadError': 'Tidak dapat memuat data pengingat pengobatan',
  'task.medication.createHeading': 'Buat Pengingat Obat',
  'task.medication.editHeading': 'Edit Pengingat Pengobatan',
  'task.medication.stepProgress': 'Langkah {{step}} / {{total}}',
  'task.medication.personLabel': 'Siapa yang butuh obat',
  'task.medication.personPlaceholder': 'misalnya Ben',
  'task.medication.suggestHeading': 'Saran anggota keluarga',
  'task.medication.personRequired': 'Silakan masukkan siapa yang membutuhkan obat',
  'task.medication.descPlaceholder': 'misalnya Minum obat diabetes',
  'task.medication.timeRequired': 'Tambahkan setidaknya satu waktu pengobatan',
  'task.medication.timesUnique': 'Waktu pengobatan harus unik',
  'task.medication.timeMax': 'Maksimal 10 kali pengobatan',
  'task.medication.timesSectionLabel': 'Waktu pengobatan',
  'task.medication.timeLabel': 'Waktu pengobatan {{n}}',
  'task.medication.removeTimeAria': 'Hapus kali ini',
  'task.medication.addTime': '+ Tambahkan waktu pengobatan',
  'task.medication.reviewTitle': 'Judul tugas',
  'task.medication.editTitleAria': 'Edit judul tugas',
  'task.medication.submitCreate': 'Buat Pengingat Obat',
  'task.medication.customTitleModalTitle': 'Judul khusus',
  'task.medication.titleChoiceTitle': 'Cara memperbarui judul',
  'task.medication.titleChoiceKeep': 'Pertahankan judul aslinya',
  'task.medication.titleChoiceUseNew': 'Gunakan judul baru',
  'task.medication.titleChoiceCustom': 'Kebiasaan',
  'task.medication.createSuccess': 'Pengingat pengobatan dibuat',
  'task.medication.updateSuccess': 'Pengingat pengobatan diperbarui',
  'task.medication.createError': 'Tidak dapat membuat pengingat pengobatan',
  'task.form.notifyEmployerLabel': 'Beritahu saya jika sudah selesai',
  'task.form.remindHelperBeforeDueLabel': 'Ingatkan pembantu sebelum waktunya',
  'task.form.remindHelperBeforeDueDisabledHint': 'Tetapkan batas waktu sebelum mengaktifkan pengingat ini.',
  'task.form.remindHelperBeforeDueModalTitle': 'Ingatkan pembantu sebelum waktunya',
  'task.form.remindHelperBeforeDueModalIntro': 'Sistem akan mencoba mengirimkan pengingat dalam waktu 10 menit sebelum batas waktu.',
  'task.form.remindHelperBeforeDueModalLimit1': 'Pembantu Anda harus mengaktifkan notifikasi (aplikasi perlu diinstal atau ditambahkan ke layar beranda) atau notifikasi email diaktifkan untuk menerima pengingat tepat waktu.',
  'task.form.remindHelperBeforeDueModalLimit2': 'Pembantu Anda memerlukan koneksi jaringan saat pengingat dikirim.',
  'task.form.remindHelperBeforeDueModalLimit3': 'Waktu pengiriman sebenarnya mungkin tertunda karena koneksi jaringan.',
  'task.medication.remindHelperBeforeDueModalIntro': 'Sistem akan mencoba mengirimkan pengingat dalam waktu 10 menit sebelum waktu pengobatan.',
  'task.medication.step3ReminderAskTitle': 'Ingatkan penolong sebelum waktu pengobatan?',
  'task.medication.step3ReminderAskYes': 'Ya, aktifkan pengingat',
  'task.medication.step3ReminderAskNo': 'Tidak, lewati pengingat',
  'task.group.wizard.stepOf': 'Langkah {{current}} / {{total}}',
  'task.group.wizard.reviewCardHeadingPickup': 'Tinjau penjemputan / pengantaran',
  'task.group.wizard.reviewCardHeadingMedication': 'Tinjau pengingat pengobatan',
  'task.group.wizard.reviewConfirmPickup': 'Buat penjemputan / pengantaran',
  'task.group.wizard.reviewConfirmMedication': 'Buat pengingat pengobatan',
  'task.group.wizard.reviewUpdatePickup': 'Simpan penjemputan / pengantaran',
  'task.group.wizard.reviewUpdateMedication': 'Simpan pengingat pengobatan',
  'task.group.wizard.summaryNone': '(Tidak ada)',
  'task.group.wizard.summaryPerson': 'Orang',
  'task.group.wizard.summaryLocation': 'Lokasi',
  'task.group.wizard.summaryExclusion': 'Rentang pengecualian',
  'task.group.wizard.summaryRequirePhoto': 'Memerlukan pengiriman foto',
  'task.group.wizard.summaryYes': 'Ya',
  'task.group.wizard.summaryNo': 'TIDAK',
  'task.group.wizard.summaryMedicationTimes': 'Waktu pengingat',
  'task.list.empty': 'Belum ada tugas',
  'task.list.emptyHint': 'Klik tombol Tambah Tugas untuk membuat tugas pertama Anda',
  'task.list.overdueEmpty': 'Tidak ada tugas yang terlambat',
  'task.list.completedCount': 'Selesai {{count}} kali',
  'task.list.pendingReviewNav': 'Tugas peninjauan yang tertunda',
  'task.list.pendingReviewNavAria': 'Tugas peninjauan tertunda, {{count}} item',
  'task.list.approvedNav': 'Disetujui',
  'task.list.approvedNavAria': 'Pengiriman tugas yang disetujui, {{count}} item',
  'task.list.loadError': 'Gagal memuat tugas',
  'task.list.pageSubtitle': 'Ikhtisar kemajuan dan tugas hari ini',
  'task.list.summaryPendingLabel': 'Tugas peninjauan yang tertunda',
  'task.list.summaryApprovedLabel': 'Disetujui',
  'task.list.summaryTomorrowLabel': 'Tugas besok',
  'task.list.tomorrowNavAria': 'Tugas besok — total {{count}}',
  'task.list.summaryCount': '{{count}} item',
  'task.list.summaryCountUnitOne': 'barang',
  'task.list.summaryCountUnitOther': 'item',
  'task.list.editFiltersAria': 'Sub-tab tugas edit',
  'task.list.tabEditAllTasks': 'Edit semua tugas',
  'task.list.menuEditAllTasks': 'Edit semua tugas',
  'task.list.menuHistoryTasks': 'Riwayat tugas sebelumnya',
  'task.list.menuFutureTasks': 'Tugas yang akan datang',
  'task.list.menuEditTask': 'Sunting tugas',
  'task.list.menuViewTask': 'Lihat tugas',
  'task.list.menuReviewTask': 'Tinjau tugas',
  'task.list.taskRowMenuAria': 'Tindakan untuk {{title}}',
  'task.list.titleMenuAria': 'Menu manajemen tugas',
  'task.list.dateStripCustom': 'Kebiasaan',
  'task.list.dateStripAria': 'Pilih tanggal',
  'task.list.customDateModalTitle': 'Pilih tanggal',
  'task.list.timeSectionLateNight': 'Larut malam',
  'task.list.timeSectionMorning': 'Pagi',
  'task.list.timeSectionAfternoon': 'Sore',
  'task.list.timeSectionEvening': 'Malam',
  'task.list.timeSectionNoTime': 'Tidak ada waktu yang ditentukan',
  'task.list.overdueCardLabel': 'Tugas yang terlambat',
  'task.list.overdueCardView': 'Melihat',
  'task.list.statusEffective': 'Aktif',
  'task.list.statusNotStarted': 'Belum dimulai',
  'task.list.statusExpired': 'Kedaluwarsa',
  'employerDashboard.greetLateNight': 'Selamat malam, {{name}}',
  'employerDashboard.greetMorning': 'Selamat pagi, {{name}}',
  'employerDashboard.greetAfternoon': 'Selamat siang, {{name}}',
  'employerDashboard.greetEvening': 'Selamat malam, {{name}}',
  'employerDashboard.loadError': 'Tidak dapat memuat dasbor',
  'employerDashboard.subtitle': 'Sekilas tentang hari ini',
  'employerDashboard.todayCompletion': 'Penyelesaian hari ini',
  'employerDashboard.completedFraction': '{{done}} / {{total}} selesai',
  'employerDashboard.completedFractionValue': '{{done}} / {{total}}',
  'employerDashboard.completedFractionStatus': 'Selesai',
  'employerDashboard.pendingTitle': 'Tugas peninjauan yang tertunda',
  'employerDashboard.pendingEmpty': 'Tidak ada kiriman yang menunggu peninjauan',
  'employerDashboard.submittedAtLine': 'Dikirim {{at}}',
  'employerDashboard.viewAllPending': 'Lihat semua yang tertunda',
  'employerDashboard.monthExpenseTitle': 'Uang yang Diberikan ({{range}})',
  'employerDashboard.budgetPlaceholder': 'Belum ada Uang aktif yang Diberikan',
  'employerDashboard.budgetTotal': 'Uang Diberikan total',
  'employerDashboard.budgetUsed': 'Dihabiskan',
  'employerDashboard.budgetRemaining': 'Tersisa',
  'employerDashboard.settlementPendingLine': '{{count}} penyelesaian perlu diperhatikan',
  'employerDashboard.ariaTodayCompletionCard': 'Buka tugas — tingkat penyelesaian hari ini',
  'employerDashboard.ariaOverdueCard': 'Buka tugas — tab terlambat',
  'employerDashboard.gettingStarted.title': 'Mulai menggunakan',
  'employerDashboard.gettingStarted.subtitle':
    'Anda sudah dipasangkan dengan Helper. Selesaikan langkah berikut agar mereka dapat bekerja dan melapor di aplikasi.',
  'employerDashboard.gettingStarted.progress': 'Selesai {{done}} / {{total}}',
  'employerDashboard.gettingStarted.done': 'Selesai',
  'employerDashboard.gettingStarted.stepCta': 'Atur',
  'employerDashboard.gettingStarted.later': 'Nanti saja',
  'employerDashboard.gettingStarted.laterAria': 'Tutup panduan mulai untuk nanti',
  'employerDashboard.gettingStarted.dismissAria': 'Tutup panduan mulai',
  'employerDashboard.gettingStarted.dismissError': 'Tidak dapat menutup panduan mulai',
  'employerDashboard.gettingStarted.dismissToast':
    'Panduan mulai ditutup. Ketuk “?” di samping sapaan untuk melihat lagi.',
  'employerDashboard.gettingStarted.helpTriggerAria': 'Lihat panduan mulai',
  'employerDashboard.gettingStarted.regionAria': 'Panduan mulai menggunakan',
  'employerDashboard.gettingStarted.stepTaskTitle': 'Buat tugas pertama',
  'employerDashboard.gettingStarted.stepTaskHint': 'Misalnya membersihkan, belanja, atau rutinitas harian',
  'employerDashboard.gettingStarted.stepTaskAria': 'Buka halaman tugas untuk membuat tugas pertama',
  'employerDashboard.gettingStarted.stepBudgetTitle': 'Atur Uang Diberikan',
  'employerDashboard.gettingStarted.stepBudgetHint':
    'Catat periode dan jumlah uang rumah tangga untuk Helper Anda',
  'employerDashboard.gettingStarted.stepBudgetAria': 'Buka tambah Uang Diberikan',
  'employerDashboard.gettingStarted.stepFamilyTitle': 'Tambah anggota keluarga',
  'employerDashboard.gettingStarted.stepFamilyHint': 'Bantu Helper mengenal data keluarga',
  'employerDashboard.gettingStarted.stepFamilyAria': 'Buka halaman anggota keluarga',
  'employerDashboard.gettingStarted.stepPinTitle': 'Tulis pesan pin',
  'employerDashboard.gettingStarted.stepPinHint': 'Helper akan melihat pengingat di beranda mereka',
  'employerDashboard.gettingStarted.stepPinAria': 'Buka buat pesan pin',
  'helperHome.greetLateNight': 'Selamat malam, {{name}}',
  'helperHome.greetMorning': 'Selamat pagi, {{name}}',
  'helperHome.greetAfternoon': 'Selamat siang, {{name}}',
  'helperHome.greetEvening': 'Selamat malam, {{name}}',
  'pinMessage.list.title': 'Sematkan pengaturan pesan',
  'pinMessage.list.subtitle': 'Ticker beranda mengikuti perintah ini. Maksimum {{maxItems}} item.',
  'pinMessage.list.savingOrder': 'Menyimpan pesanan…',
  'pinMessage.list.empty': 'Belum ada pesan pin.',
  'pinMessage.form.addTitle': 'Tambahkan pesan pin',
  'pinMessage.form.editTitle': 'Edit pesan pin',
  'pinMessage.form.limitLine': 'Batas level saat ini: judul {{titleMax}}, konten {{contentMax}}.',
  'pinMessage.form.saving': 'Penghematan…',
  'pinMessage.field.title': 'Judul',
  'pinMessage.field.titlePlaceholder': 'Contoh: Besok obral di supermarket, ingat beli kecap',
  'pinMessage.field.content': 'Isi',
  'pinMessage.field.contentPlaceholder': 'Pesan yang disematkan secara mendetail...',
  'pinMessage.field.visibility': 'Visibilitas',
  'pinMessage.field.icon': 'Ikon',
  'pinMessage.field.displayFrom': 'Tampilan dari',
  'pinMessage.field.displayTo': 'Tampilkan ke',
  'pinMessage.field.status': 'Status',
  'pinMessage.status.active': 'Aktif',
  'pinMessage.status.inactive': 'Tidak aktif',
  'pinMessage.visibility.both': 'Majikan + Pembantu',
  'pinMessage.visibility.employerOnly': 'Hanya majikan',
  'pinMessage.icon.info': 'Informasi',
  'pinMessage.icon.remind': 'Mengingatkan',
  'pinMessage.icon.specialAlert': 'Peringatan khusus',
  'pinMessage.window.always': 'Selalu terlihat',
  'pinMessage.window.range': '{{from}} ke {{to}}',
  'pinMessage.window.from': 'Dari {{from}}',
  'pinMessage.window.to': 'Sampai {{to}}',
  'pinMessage.action.add': 'Tambahkan pesan pin',
  'pinMessage.action.edit': 'Sunting',
  'pinMessage.action.remove': 'Menghapus',
  'pinMessage.action.save': 'Menyimpan',
  'pinMessage.action.cancel': 'Membatalkan',
  'pinMessage.action.close': 'Menutup',
  'pinMessage.detail.createdAt': 'Dibuat pada: {{value}}',
  'pinMessage.detail.updatedAt': 'Terakhir diubah: {{value}}',
  'pinMessage.action.moveUp': 'Naik',
  'pinMessage.action.moveDown': 'Pindah ke bawah',
  'pinMessage.confirm.remove': 'Hapus pesan pin ini?',
  'pinMessage.error.loadList': 'Gagal memuat pesan pin',
  'pinMessage.error.saveOrder': 'Gagal menyimpan pesanan',
  'pinMessage.error.remove': 'Gagal menghapus pesan pin',
  'pinMessage.error.notFound': 'Pesan pin tidak ditemukan',
  'pinMessage.error.loadForm': 'Gagal memuat formulir',
  'pinMessage.error.titleContentRequired': 'Judul dan konten diperlukan',
  'pinMessage.error.titleMax': 'Judul tidak boleh melebihi {{max}} karakter',
  'pinMessage.error.contentMax': 'Konten tidak boleh melebihi {{max}} karakter',
  'pinMessage.error.dateOrder': 'Tampilan dari tanggal harus sebelum tampilan hingga tanggal',
  'pinMessage.error.save': 'Gagal menyimpan pesan pin',
  'pinMessage.ticker.openDetails': 'Buka detail pesan pin',
  'pinMessage.ticker.prev': 'Pesan pin sebelumnya',
  'pinMessage.ticker.next': 'Pesan pin berikutnya',
  'pinMessage.ticker.title': 'Sematkan Pesan',
  'pinMessage.ticker.count': '{{current}}/{{total}}',
  'helperHome.loadError': 'Tidak dapat memuat ke rumah',
  'helperHome.summaryLine': '{{count}} tugas hari ini · {{budget}} tersisa',
  'helperHome.dataPlaceholder': '—',
  'helperHome.cardTodayTasks': 'Sisa Tugas Hari ini',
  'helperHome.todayCompletion': 'Penyelesaian hari ini',
  'helperHome.submittedFraction': '{{done}} / {{total}}',
  'helperHome.submittedFractionValue': '{{done}} / {{total}}',
  'helperHome.submittedFractionStatus': 'Dikirim',
  'helperHome.todayTaskBreakdown': 'Total: {{total}} · Selesai: {{done}}',
  'helperHome.cardOverdueTasks': 'Tugas yang terlambat',
  'helperHome.overdueTasksHint': 'Tugas tidak selesai melewati batas waktunya',
  'helperHome.weeklyBudgetTitle': 'Uang Diterima ({{range}})',
  'helperHome.detailsLabel': 'Detail',
  'helperHome.remainingLabel': 'Tetap',
  'helperHome.totalLabel': 'Total',
  'helperHome.doneLabel': 'Selesai',
  'helperHome.budgetSpentOverTotal': 'Dibelanjakan / Uang Diterima',
  'helperHome.budgetSpentLabel': 'Dihabiskan',
  'helperHome.budgetReceivedLabel': 'Diterima',
  'helperHome.budgetRemainingLabel': 'Tersisa',
  'helperHome.budgetOverspentLabel': 'Menghabiskan uang terlalu banyak',
  'helperHome.balanceBadge': '{{amount}} tersisa',
  'helperHome.overspentBadge': 'Pembelanjaan berlebihan {{amount}}',
  'helperHome.weeklyBudgetPlaceholder': 'Belum ada data Uang yang Diterima',
  'helperHome.budgetUsedFootnote': 'Menghabiskan {{used}}',
  'helperHome.actionScanReceipt': 'Pindai tanda terima',
  'helperHome.actionScanReceiptSub': 'Ekstrak AI dan kirimkan',
  'helperHome.tomorrowBadge': '{{count}}',
  'helperHome.actionTomorrow': 'Tugas besok',
  'helperHome.actionTomorrowSub': 'Pratinjau daftar besok',
  'helperHome.actionReceiptList': 'Daftar tanda terima',
  'helperHome.actionReceiptListSub': 'Lihat dan lacak',
  'helperHome.settlementReadyBadge': 'Menetap',
  'helperHome.actionSettlement': 'Setuju & Selesaikan',
  'helperHome.actionViewDetails': 'Lihat detailnya',
  'helperHome.actionSettlementSub': 'Pengeluaran dan periode',
  'helperHome.todayPreviewTitle': 'Pratinjau hari ini',
  'helperHome.suggestedTime': 'Tenggat waktu',
  'helperHome.viewAllTasks': 'Lihat semua tugas',
  'helperHome.ariaTodayTasksCard': 'Buka halaman Tugas tab Hari Ini',
  'helperHome.ariaTodayCompletionCard': 'Buka tugas — tingkat penyelesaian hari ini',
  'helperHome.ariaOverdueTasksCard': 'Buka tab Tugas di halaman Terlambat',
  'helperHome.ariaMoneyReceivedCard': 'Buka biaya dan rincian penyelesaian',
  'task.pendingReview.title': 'Tugas peninjauan yang tertunda',
  'task.pendingReview.subtitle': 'Pembantu Anda mengirimkan ini — harap tinjau',
  'task.pendingReview.empty': 'Tidak ada kiriman yang menunggu peninjauan',
  'task.pendingReview.backToTasks': 'Kembali ke manajemen tugas',
  'task.pendingReview.dueDate': 'Tenggat waktu',
  'task.pendingReview.submittedAt': 'Dikirim pada',
  'task.pendingReview.submittedAtTime': 'Dikirim: {{time}}',
  'task.pendingReview.review': 'Tinjauan',
  'task.pendingReview.reviewCta': 'Ulasan: {{title}}',
  'task.pendingReview.loadError': 'Gagal memuat ulasan yang tertunda',
  'task.approvedList.title': 'Disetujui',
  'task.approvedList.subtitle': 'Kiriman yang telah Anda setujui',
  'task.approvedList.empty': 'Belum ada kiriman yang disetujui',
  'task.approvedList.backToTasks': 'Kembali ke manajemen tugas',
  'task.approvedList.dueDate': 'Tenggat waktu',
  'task.approvedList.submittedAt': 'Dikirim pada',
  'task.approvedList.reviewedAt': 'Disetujui di',
  'task.approvedList.view': 'Lihat detailnya',
  'task.approvedList.viewCta': 'Lihat: {{title}}',
  'task.approvedList.loadError': 'Gagal memuat daftar yang disetujui',
  'task.form.createTitle': 'Buat Tugas',
  'task.form.editTitle': 'Sunting Tugas',
  'task.form.titleLabel': 'Judul Tugas',
  'task.form.titlePlaceholder': 'misalnya, membersihkan ruang tamu',
  'task.form.descLabel': 'Keterangan',
  'task.form.descLabelOptional': 'Deskripsi (opsional)',
  'task.form.descPlaceholder': 'Jelaskan tugas tersebut secara rinci...',
  'task.form.recurrenceLabel': 'Kambuh',
  'task.form.daysLabel': 'hari',
  'task.form.daysHint': 'Pilih hari untuk tugas mingguan/dua mingguan',
  'task.form.recurrenceWeekdaysRequired': 'Pilih setidaknya satu hari untuk tugas mingguan atau dua mingguan',
  'task.form.occurrenceDateLabel': 'Tanggal kejadian',
  'task.form.startDateLabel': 'Tanggal mulai',
  'task.form.endDateLabel': 'Tanggal akhir',
  'task.form.endDateLabelOptional': 'Tanggal akhir (opsional)',
  'task.form.excludeRangesLabel': 'Rentang tanggal yang dikecualikan',
  'task.form.addExcludeRange': 'Tambahkan rentang pengecualian',
  'task.form.removeExcludeRange': 'Menghapus',
  'task.form.excludeStartDateLabel': 'Kecualikan tanggal mulai',
  'task.form.excludeEndDateLabel': 'Kecualikan tanggal akhir',
  'task.form.dueTimeLabel': 'Waktu Jatuh Tempo',
  'task.form.dueTimeLabelOptional': 'Batas Waktu (opsional)',
  'task.form.dueTimePlaceholder': 'misalnya, 18:00',
  'task.form.requirePhotoLabel': 'Memerlukan pengiriman foto',
  'task.form.notifyLabel': 'Beritahu saya jika sudah selesai',
  'task.form.submit': 'Simpan Tugas',
  'task.form.submitting': 'Penghematan...',
  'task.form.createSuccess': 'Tugas berhasil dibuat',
  'task.form.updateSuccess': 'Tugas berhasil diperbarui',
  'task.form.createError': 'Gagal membuat tugas',
  'task.form.updateError': 'Gagal memperbarui tugas',
  'task.form.cancel': 'Membatalkan',
  'task.review.title': 'Tinjau Tugas',
  'task.review.stockTakeDetailTitle': 'Detail Stok Rumah',
  'task.review.inventoryTaskSummaryTitle': 'Ringkasan Tugas Stok Rumah',
  'task.review.latestHomeStockTitle': 'Stok Rumah Terbaru',
  'task.review.latestHomeStockOpenRecentAria': 'Buka pengiriman Stok Rumah terbaru',
  'task.review.latestHomeStockRecentTitle': 'Kiriman terbaru',
  'task.review.latestHomeStockTaskDate': 'Tanggal tugas',
  'task.review.latestHomeStockSubmittedAt': 'Dikirim pada',
  'task.review.latestHomeStockStatus': 'Status',
  'task.review.latestHomeStockEmptyEmployer': 'Belum ada Stok Rumah yang dikirimkan oleh pembantu Anda.',
  'task.review.latestHomeStockEmptyHelper': 'Belum ada catatan Stok Rumah.',
  'task.review.addHomeStockTaskFab': 'Tambahkan Tugas Stok Rumah',
  'task.review.addHomeStockTaskFabAria': 'Tambahkan tugas Stok Rumah',
  'task.review.stocktakePhotosHeading': 'Foto Stok Rumah',
  'task.review.stocktakeResultsHeading': 'Hasil Stok Rumah',
  'task.review.stockLevelLegendButton': 'Legenda',
  'task.review.stockLevelLegendButtonAria': 'Tampilkan legenda ikon tingkat stok',
  'task.review.stockLevelLegendPanelAria': 'Legenda ikon tingkat stok',
  'task.review.stockLevelLegend.full': 'Penuh',
  'task.review.stockLevelLegend.half': 'Setengah',
  'task.review.stockLevelLegend.low': 'Rendah',
  'task.review.stockLevelLegend.empty': 'Kosong',
  'task.review.inventoryPhotosHeading': 'Foto stok rumah',
  'task.review.inventoryLocationSummaryTitle': 'Ringkasan ulasan Stok Rumah berdasarkan lokasi',
  'task.review.inventoryLocationSummaryLoading': 'Memuat ringkasan...',
  'task.review.inventoryLocationSummaryCounts': '{{itemCount}} item · {{photoCount}} foto',
  'task.review.inventoryLocationSummaryWithItems': 'Kategori dengan item',
  'task.review.inventoryLocationSummaryNoItems': 'Kategori tidak menandai item',
  'task.review.inventoryLocationSummaryNone': 'Tidak ada',
  'task.review.inventoryLocationSummaryEmpty': 'Belum ada ringkasan lokasi.',
  'task.review.helperSubmitHomeStock': 'Kirim Stok Rumah',
  'task.review.helperResubmitHomeStock': 'Kirim Ulang Stok Rumah',
  'task.review.inventoryLineAwaiting': 'Menunggu detail garis',
  'task.review.inventoryLinePendingBody': 'Level stok dan foto muncul setelah pembantu mengirimkan.',
  'task.review.inventorySharedPhotoNote': 'Foto sama dengan item di atas.',
  'task.review.inventoryStatLocationsCaption': 'LOKASI',
  'task.review.inventoryStatTotalPhotosCaption': 'FOTO',
  'task.review.inventoryStatLowStockCaption': 'STOCK RENDAH',
  'task.review.inventoryStatExpiringCaption': 'SEGERA BERAKHIR',
  'task.review.inventoryFilterCategoriesHeading': 'Filter kategori',
  'task.review.inventoryLocationPhotosEmpty': 'Belum ada foto untuk lokasi ini.',
  'task.review.inventoryItemsFilteredEmpty': 'Tidak ada item yang cocok dengan filter kategori saat ini.',
  'task.review.inventoryNoCategoriesInLocation': 'Tidak ada kategori untuk difilter untuk lokasi ini.',
  'task.review.inventoryToggleCategoryAria': 'Kategori filter: {{category}}',
  'task.review.inventoryCategoryEmptyAtLocationBody': 'Tidak ada item yang dihitung untuk kategori ini di lokasi ini.',
  'task.review.inventoryExpiryExpired': 'Kedaluwarsa',
  'task.review.inventoryExpiryToday': 'Kedaluwarsa hari ini',
  'task.review.inventoryExpiryTomorrow': 'Kedaluwarsa besok',
  'task.review.inventoryExpiryInDays': 'Berakhir dalam {{count}} hari',
  'task.review.inventoryExpiryAbsolute': '{{date}} habis masa berlakunya',
  'task.review.inventoryLocationTabsAria': 'Pilih lokasi inventaris',
  'task.review.inventoryLocationsSectionHeading': 'Lokasi',
  'task.review.inventoryLocationsFilterReminder': 'Pilih tab lokasi di bawah untuk memfilter foto dan item untuk tempat itu.',
  'task.review.inventoryLocationsCoachmarkDismissAria': 'Tutup tip lokasi',
  'task.review.detailTitle': 'Detail tugas',
  'task.review.helperAwaitingEmployerBanner': 'Tugas ini telah diserahkan dan menunggu majikan Anda meninjaunya.',
  'task.review.futureDueDetailOnly': 'Tugas ini belum dapat diserahkan. Anda hanya dapat melihat detailnya di sini.',
  'task.review.futureDueOutOfRange': 'Tugas ini berada di luar jendela pengiriman awal. Anda hanya dapat melihat detailnya di sini.',
  'task.review.futureDueEmployerTomorrow': 'Tugas ini dijadwalkan untuk besok.',
  'task.review.futureDueEmployerDays': 'Tugas ini dijadwalkan {{days}} hari dari sekarang.',
  'task.review.futureDueHelperTomorrow': 'Tugas ini dijadwalkan untuk besok. Harap catat tanggal tugas!',
  'task.review.futureDueHelperDays': 'Tugas ini dijadwalkan {{days}} hari dari sekarang. Harap catat tanggal tugas!',
  'task.todo.futureSubmitBanner': 'Anda dapat mengirimkan tugas yang akan datang lebih awal',
  'task.todo.tabFuture': 'Masa depan',
  'task.todo.helperEmptyFuture': 'Tidak ada tugas dalam rentang tanggal ini',
  'task.todo.helperEmptyFutureHint': 'Coba rentang lain atau tanyakan kepada perusahaan Anda.',
  'task.submitConfirmTitle': 'Kirimkan tugas ini?',
  'task.submitConfirmPrompt': 'Tanggal tugas ditunjukkan di bawah. Konfirmasi pengiriman?',
  'task.submitConfirmAction': 'Konfirmasikan pengiriman',
  'task.submitConfirm.dueDateTomorrow': '{{date}} (Besok)',
  'task.submitConfirm.dueDateDaysLater': '{{date}} (dalam {{days}} hari)',
  'task.review.taskInfo': 'Info Tugas',
  'task.review.submittedBy': 'Dikirim oleh',
  'task.review.taskDate': 'Tanggal tugas',
  'task.review.completedAt': 'Selesai pada',
  'task.review.submittedAt': 'Dikirim pada',
  'task.review.photos': 'Foto',
  'task.review.prevPhoto': 'Foto sebelumnya',
  'task.review.nextPhoto': 'Foto selanjutnya',
  'task.review.photoCount': '{{current}} / {{total}}',
  'task.review.gpsLocation': 'Lokasi GPS',
  'task.review.gpsDisabled': 'GPS tidak diaktifkan',
  'task.review.gpsStaticMapAlt': 'Lokasi tugas yang dikirimkan (pratinjau peta)',
  'task.review.openInGoogleMaps': 'Buka di Google Maps',
  'task.review.openInGoogleMapsAria': 'Buka lokasi ini di Google Maps di tab baru',
  'task.review.osmCopyright': '© Kontributor OpenStreetMap',
  'task.review.addressLabel': 'Alamat',
  'task.review.addressLoading': 'Mencari alamat…',
  'task.review.addressUnavailable': 'Tidak ada teks alamat yang tersedia untuk lokasi ini',
  'task.review.note': 'Catatan',
  'task.review.noNote': 'Tidak ada catatan',
  'task.review.reviewPrompt': 'Silakan tinjau ↓',
  'task.review.approve': 'Menyetujui',
  'task.review.reject': 'Menolak',
  'task.review.needsUpdate': 'Perlu Pembaruan',
  'task.review.needsUpdateModalTitle': 'Perlu pembaruan',
  'task.review.needsUpdateReasonPrompt': 'Masukkan mengapa kiriman ini perlu diubah.',
  'task.review.needsUpdateReasonTooShort': 'Alasannya terlalu singkat. Minimal {{min}} karakter.',
  'task.review.needsUpdatePhotoHint': 'Pembantu dapat menghapus foto yang salah dan mengunggah foto yang benar saat mengirimkan ulang.',
  'task.review.reviewSuccess': 'Tinjauan dikirimkan',
  'task.review.reviewError': 'Peninjauan gagal',
  'task.review.versionConflict': 'Data telah diubah, harap muat ulang',
  'task.review.loadError': 'Gagal memuat detail tugas',
  'comment.sectionTitle': 'Komentar',
  'comment.usage': '{{used}} / {{max}} komentar digunakan',
  'comment.charCount': '{{current}} / {{max}} karakter',
  'comment.placeholder': 'Tulis komentar…',
  'comment.writeButton': 'Tulis komentar',
  'comment.modalTitle': 'Tulis komentar',
  'comment.draftPending': 'Draf',
  'comment.send': 'Mengirim',
  'comment.sending': 'Mengirim…',
  'comment.loadError': 'Gagal memuat komentar',
  'comment.sendError': 'Gagal mengirim komentar',
  'comment.empty': 'Belum ada komentar',
  'comment.limitReached': 'Batas komentar telah tercapai untuk item ini.',
  'comment.sendAria': 'Kirim komentar',
  'comment.listAria': 'Daftar komentar',
  'comment.emptyDraft': 'Silakan masukkan komentar',
  'comment.tooLong': 'Komentar tidak boleh melebihi {{max}} karakter',
  'comment.shortcutHint': 'Tekan Ctrl+Enter atau Cmd+Enter untuk mengirim',
  'comment.unsentSubmit.title': 'Komentar tidak terkirim',
  'comment.unsentSubmit.descriptionTask': 'Anda mengetik komentar tetapi tidak menekan Kirim. Kirimkan tugas dan kirimkan komentar ini bersama-sama?',
  'comment.unsentSubmit.descriptionStockTake': 'Anda mengetik komentar tetapi tidak menekan Kirim. Kirim Stok Rumah dan posting komentar ini bersama-sama?',
  'comment.unsentSubmit.descriptionResubmit': 'Anda mengetik komentar tetapi tidak menekan Kirim. Kirim ulang tugas dan kirimkan komentar ini bersama-sama?',
  'comment.unsentSubmit.backToEdit': 'Kembali untuk mengedit',
  'comment.unsentSubmit.submitOnlyTask': 'Kirimkan tugas saja',
  'comment.unsentSubmit.submitOnlyStockTake': 'Kirimkan Stok Rumah saja',
  'comment.unsentSubmit.submitOnlyResubmit': 'Kirim ulang saja',
  'comment.unsentSubmit.submitWithComment': 'Kirim dan kirim komentar',
  'comment.unsentSubmit.working': 'Harap tunggu…',
  'notification.bellAria': 'Pemberitahuan',
  'notification.panelTitle': 'Pemberitahuan',
  'notification.empty': 'Tidak ada pemberitahuan',
  'notification.markAllRead': 'Tandai semua sebagai telah dibaca',
  'notification.markAllReadAria': 'Tandai semua notifikasi sebagai telah dibaca',
  'notification.loadError': 'Gagal memuat notifikasi',
  'notification.expand': 'Lihat semua ▼',
  'notification.collapse': 'Tutup ▲',
  'notification.expandAria': 'Tampilkan teks notifikasi lengkap',
  'notification.collapseAria': 'Ciutkan teks notifikasi',
  'task.today.title': 'Daftar tugas',
  'task.today.subtitle': 'Telusuri tugas berdasarkan riwayat, lewat waktu, hari ini, dan masa depan',
  'task.today.empty': 'Tidak ada tugas untuk hari ini',
  'task.today.emptyHint': 'Beristirahat!',
  'task.todo.helperEmptyOverdue': 'Tidak ada tugas yang terlambat saat ini',
  'task.todo.helperEmptyOverdueHint': 'Tetap selesaikan tugas sebelum tenggat waktunya.',
  'task.todo.helperEmptyTomorrow': 'Belum ada jadwal untuk besok',
  'task.todo.helperEmptyTomorrowHint': 'Periksa kembali nanti atau tanyakan kepada atasan Anda apakah ada yang ditambahkan.',
  'task.today.complete': 'Menyelesaikan',
  'task.today.view': 'Melihat',
  'task.today.pendingReview': '{{count}} tugas menunggu peninjauan oleh perusahaan Anda',
  'task.today.sectionNotSubmitted': 'Tidak diserahkan',
  'task.today.sectionNeedsUpdate': 'Perlu pembaruan',
  'task.today.sectionCompleted': 'Selesai',
  'task.today.employerFeedbackLabel': 'Pesan majikan:',
  'task.today.dueAt': 'Jatuh tempo pada {{time}}',
  'task.today.cannotSubmitTomorrow': 'Tersedia besok',
  'task.today.tomorrowSubmitBanner': 'Anda dapat mengirimkan tugas di bawah ini mulai besok.',
  'task.todo.tabHistory': 'Sejarah',
  'task.todo.tabOverdue': 'Terlambat',
  'task.todo.tabToday': 'Hari ini',
  'task.todo.tabTomorrow': 'Besok',
  'task.todo.deadlineToday': 'Hari ini',
  'task.todo.deadlineTomorrowShort': 'Tmr.',
  'task.todo.inventoryPreviewLocationsLabel': 'Lokasi',
  'task.todo.inventoryPreviewCategoriesLabel': 'Kategori',
  'task.todo.receiptScanBanner': 'Pindai tanda terima untuk mencatat pengeluaran dengan cepat',
  'task.history.startDate': 'Tanggal mulai',
  'task.history.endDate': 'Tanggal akhir',
  'task.history.filterAria': 'Filter riwayat tugas berdasarkan status',
  'task.history.statusAll': 'Semua',
  'task.history.empty': 'Tidak ada tugas yang cocok dengan filter Anda dalam rentang tanggal ini',
  'task.history.emptyHint': 'Sesuaikan rentang tanggal atau filter status',
  'task.history.relativeToday': 'Hari ini',
  'task.history.relativeYesterday': 'Kemarin',
  'task.history.relativeTomorrow': 'Besok',
  'task.history.dateHeadingWithRelative': '{{date}} ({{relative}})',
  'task.history.groupTotalCount': '{{count}} catatan',
  'task.history.completionTime': 'Selesai: {{time}}',
  'task.employerFuture.title': 'Tugas yang akan datang',
  'task.employerFuture.empty': 'Tidak ada tugas dalam rentang tanggal ini',
  'task.employerFuture.loadError': 'Gagal memuat tugas yang akan datang',
  'task.employerFuture.openDetailCta': 'Lihat tugas: {{title}}',
  'task.today.loadError': 'Gagal memuat tugas',
  'receipt.analyze.navLink': 'Penerimaan AI',
  'receipt.analyze.title': 'Penerimaan analisis AI',
  'receipt.analyze.subtitle': 'Pilih foto tanda terima; bidang diisi secara otomatis (Anda dapat mengedit)',
  'receipt.analyze.pickImages': 'Unggah gambar tanda terima (Maks. 10 gambar per batch)',
  'receipt.analyze.pickImagesAria': 'Pilih file gambar tanda terima',
  'receipt.analyze.analyzing': 'Menganalisis…',
  'receipt.analyze.analyzingProgress': 'Menganalisis {{current}} / {{total}}',
  'receipt.analyze.analyzeError': 'Analisis gagal',
  'receipt.analyze.rateLimit': 'Batas analisis AI harian tercapai ({{used}} / {{limit}}). Coba lagi setelah {{retryAt}}.',
  'receipt.analyze.manualHint': 'Analisis gagal — silakan masukkan atau perbaiki kolom secara manual.',
  'receipt.analyze.fileTooLarge': 'File melebihi 10 MB',
  'receipt.analyze.badType': 'Jenis gambar tidak didukung',
  'receipt.analyze.tooManyFiles': 'Maksimal 10 gambar',
  'receipt.analyze.field.company': 'Perusahaan / merek',
  'receipt.analyze.field.shop': 'Toko/cabang',
  'receipt.analyze.field.date': 'Tanggal',
  'receipt.analyze.field.currency': 'Mata uang',
  'receipt.analyze.field.total': 'Total',
  'receipt.analyze.field.remark': 'Komentar',
  'receipt.analyze.aiRemarkLabel': 'Komentar sistem',
  'receipt.analyze.items': 'Item baris',
  'receipt.analyze.itemsAction': 'Tindakan',
  'receipt.analyze.itemName': 'Barang',
  'receipt.analyze.qty': 'Jumlah',
  'receipt.analyze.amount': 'Jumlah',
  'receipt.analyze.addItem': 'Tambahkan baris',
  'receipt.analyze.removeItem': 'Menghapus',
  'receipt.analyze.removeRow': 'Hapus tanda terima ini',
  'receipt.analyze.removeConfirmTitle': 'Hapus tanda terima ini?',
  'receipt.analyze.removeConfirmBody': 'Entri yang dianalisis ini akan dibuang.',
  'receipt.analyze.leaveConfirmTitle': 'Tinggalkan halaman ini?',
  'receipt.analyze.leaveConfirmBody': 'Anda memiliki foto resi dan data yang belum dikirimkan. Mereka akan hilang jika Anda pergi.',
  'receipt.analyze.leaveConfirmLeave': 'Meninggalkan',
  'receipt.analyze.leaveConfirmStay': 'Tetap di halaman ini',
  'receipt.analyze.budgetLabel': 'Periode Uang Diterima',
  'receipt.analyze.budgetRequired': 'Silakan pilih periode Uang Diterima',
  'receipt.analyze.dateLabel': 'Tanggal penerimaan',
  'receipt.analyze.dateRequired': 'Silakan pilih tanggal penerimaan yang valid',
  'receipt.analyze.companyRequired': 'Silakan masukkan perusahaan/merek',
  'receipt.analyze.submit': 'Menyimpan',
  'receipt.analyze.submitAll': 'Simpan Semua Tanda Terima',
  'receipt.analyze.submitting': 'Mengirimkan…',
  'receipt.analyze.submittingAllProgress': 'Menyimpan {{current}} / {{total}}',
  'receipt.analyze.submitSuccess': 'Dikirim',
  'receipt.analyze.submittedDueToPendingSettlement': 'Tanggal penerimaan ini berada dalam masa penyelesaian yang tertunda, sehingga langsung ditandai sebagai "Dikirim".',
  'receipt.analyze.submitError': 'Pengiriman gagal',
  'receipt.analyze.needImageUrl': 'URL gambar yang disimpan tidak ada — tidak dapat dikirimkan (periksa penyimpanan cloud)',
  'receipt.analyze.invalidTotal': 'Masukkan jumlah total yang valid',
  'receipt.analyze.totalMismatchBanner': 'Total ({{total}}) tidak cocok dengan item baris ({{lineSum}}). Silakan periksa.',
  'receipt.analyze.totalMismatchConfirmTitle': 'Ketidaksesuaian jumlah',
  'receipt.analyze.totalMismatchConfirmSingle': 'Total penerimaan ({{total}}) tidak cocok dengan item baris ({{lineSum}}). Silakan periksa. Penyelesaiannya menggunakan total ({{total}}). Konfirmasi untuk menyimpan?',
  'receipt.analyze.totalMismatchConfirmBatchLine': '{{date}} {{company}} tanda terima: total ({{total}}) tidak cocok dengan item baris ({{lineSum}}). Silakan periksa.',
  'receipt.analyze.totalMismatchConfirmBatchIntro': 'Tanda terima berikut memiliki total yang tidak sesuai dengan item baris:',
  'receipt.analyze.totalMismatchConfirmBatchFooter': 'Penyelesaiannya menggunakan total penerimaan. Konfirmasi untuk menyimpan?',
  'receipt.analyze.totalMismatchConfirmConfirm': 'Konfirmasikan penyimpanan',
  'receipt.analyze.backToday': 'Kembali ke hari ini',
  'receipt.detail.title': 'Detail tanda terima',
  'receipt.detail.backToList': 'Kembali ke daftar tanda terima',
  'receipt.detail.loadError': 'Tidak dapat memuat tanda terima',
  'receipt.detail.total': 'Total',
  'receipt.detail.date': 'Tanggal penerimaan',
  'receipt.detail.submittedAt': 'Dikirim pada',
  'receipt.detail.employerReviewSubmittedAt': 'Tinjauan pemberi kerja diserahkan pada',
  'receipt.detail.delete': 'Hapus tanda terima',
  'receipt.detail.deleteHint': 'Anda hanya dapat menghapus resi yang tertunda, perlu diperbarui, atau dibatalkan.',
  'receipt.detail.deleteConfirmTitle': 'Hapus tanda terima ini?',
  'receipt.detail.deleteConfirmBody': 'Hal ini tidak dapat dibatalkan. Komentar pada tanda terima ini juga akan dihapus.',
  'receipt.detail.deleting': 'Menghapus…',
  'receipt.detail.cannotDelete': 'Tanda terima ini tidak dapat dihapus dalam statusnya saat ini.',
  'receipt.detail.photoHeading': 'Foto tanda terima',
  'receipt.detail.photoAlt': 'Foto tanda terima',
  'receipt.detail.employerSavedReceiptNotice': 'Tanggal ini belum ditetapkan, dan tanda terima ini belum diserahkan secara resmi; pembantu masih dapat mengeditnya.',
  'receipt.detail.helperUnsettledBanner': 'Tanda terima ini belum termasuk dalam penyelesaian',
  'receipt.detail.helperUnsettledBannerCta': 'Setuju & Selesaikan',
  'receipt.detail.helperUnsettledBannerCtaAria': 'Buka Biaya & penyelesaian untuk mengirimkan penyelesaian',
  'receipt.detail.editReceipt': 'Edit tanda terima',
  'receipt.detail.changeReviewStatus': 'Ubah status',
  'receipt.detail.changeReviewStatusAria': 'Buka dialog perubahan status tanda terima',
  'receipt.detail.changeReviewStatusTitle': 'Ubah status peninjauan tanda terima',
  'receipt.detail.changeReviewStatusBody': 'Silakan pilih status ulasan baru.',
  'receipt.edit.title': 'Edit tanda terima',
  'receipt.edit.subtitle':
    'Hanya tanda terima “Belum diselesaikan” yang dapat diedit sebelum penyerahan penyelesaian.',
  'receipt.edit.backToDetail': 'Kembali ke detail tanda terima',
  'receipt.edit.save': 'Simpan perubahan',
  'receipt.edit.saving': 'Penghematan…',
  'receipt.edit.saveError': 'Gagal menyimpan',
  'receipt.edit.blockedStatus':
    'Tanda terima ini tidak dapat diedit. Hanya resi Anda berstatus “Belum diselesaikan” yang dapat diedit.',
  'receipt.edit.blockedNotOwner': 'Anda hanya dapat mengedit tanda terima yang Anda kirimkan.',
  'receipt.analyze.photoHeading': 'Foto tanda terima',
  'receipt.analyze.photoHeadingOfTotal': 'Foto tanda terima ({{current}} dari {{total}})',
  'receipt.analyze.photoAlt': 'Foto tanda terima',
  'receipt.analyze.enlargeImageAria': 'Lihat foto resi ukuran penuh',
  'receipt.analyze.openDetailAria': 'Buka detail tanda terima',
  'receipt.analyze.scanMore': 'Pindai lebih banyak tanda terima',
  'receipt.analyze.nextStepSheetTitle': 'Tanda terima disimpan',
  'receipt.analyze.nextStepSheetLead': 'Langkah berikutnya: kirim penyelesaian ke majikan.',
  'receipt.analyze.nextStepSheetUploadAll':
    'Unggah semua tanda terima untuk periode penyelesaian di bawah sebelum menyelesaikan.',
  'receipt.analyze.nextStepSheetLockNote':
    'Setelah penyelesaian dikirim, tanda terima dalam periode dikirim ke majikan. Anda tidak dapat mengunggah atau mengedit tanda terima untuk tanggal tersebut.',
  'receipt.analyze.nextStepSheetEmployerReview':
    'Majikan meninjau hanya setelah Anda mengirimkan penyelesaian.',
  'receipt.analyze.nextStepSheetPeriodLabel': 'Periode penyelesaian',
  'receipt.analyze.nextStepSheetPeriodRange': '{{start}} – {{end}}',
  'receipt.analyze.nextStepSheetPeriodLoading': 'Memuat periode penyelesaian…',
  'receipt.analyze.nextStepSheetPeriodUnknown':
    'Belum ada periode Uang Diterima yang cocok. Anda tetap bisa buka Biaya & penyelesaian nanti untuk memilih periode dan mengirim.',
  'receipt.analyze.nextStepSheetPeriodLocked': 'Terkunci',
  'receipt.analyze.nextStepSheetLockedHint':
    'Periode yang cocok sudah memiliki penyelesaian aktif atau terkunci. Periksa detail di halaman biaya.',
  'receipt.analyze.nextStepSheetGoSettle': 'Ke penyelesaian',
  'receipt.analyze.nextStepSheetGoSettleAria': 'Buka Biaya & penyelesaian untuk mengirim',
  'receipt.analyze.nextStepSheetLater': 'Nanti',
  'receipt.analyze.nextStepSheetLaterAria': 'Tutup pengingat dan kirim penyelesaian nanti',
  'receipt.list.title': 'Daftar tanda terima',
  'receipt.list.subtitle': 'Lihat status tanda terima dan waktu pengiriman',
  'receipt.list.filterAria': 'Filter tanda terima berdasarkan status',
  'receipt.list.filter.all': 'Semua',
  'receipt.list.filter.save': 'Belum diselesaikan',
  'receipt.list.filter.submitted': 'Diajukan untuk penyelesaian',
  'receipt.list.filter.reviewed': 'Ditinjau',
  'receipt.list.startDate': 'Tanggal mulai (opsional)',
  'receipt.list.endDate': 'Tanggal akhir (opsional)',
  'receipt.list.requiredStartDate': 'Tanggal mulai',
  'receipt.list.requiredEndDate': 'Tanggal akhir',
  'receipt.list.empty': 'Tidak ada tanda terima yang cocok dengan filter ini.',
  'receipt.list.loadError': 'Tidak dapat memuat daftar tanda terima',
  'receipt.list.loadMore': 'Muat lebih banyak',
  'receipt.list.openDetailAria': 'Buka tanda terima {{date}}: {{summary}}',
  'receipt.list.submittedAtLine': 'Dikirim pada: {{at}}',
  'budget.title': 'Uang Diberikan',
  'budget.subtitle': 'Tetapkan periode dan jumlah Uang Utama dan Uang Tambahan',
  'budget.tabActive': 'Sedang berlangsung',
  'budget.tabSettled': 'Mapan',
  'budget.tabsAria': 'Kategori daftar Uang Diberikan',
  'budget.addNew': 'Uang Baru Diberikan',
  'budget.addNewAria': 'Buat periode Uang Diberikan baru',
  'budget.addOn': 'Menambahkan',
  'budget.addOnAria': 'Uang Tambahan untuk periode ini',
  'budget.form.addOnCreateTitle': 'Uang Tambahan',
  'budget.form.parentPeriod': 'Periode utama',
  'budget.empty': 'Tidak ada data',
  'budget.emptySettled': 'Belum ada periode Uang Diberikan yang diselesaikan.',
  'budget.emptyHint': 'Buat Uang Diberikan sehingga pembantu Anda dapat menandai tanda terima dan menjalankan penyelesaian.',
  'budget.filterStartDate': 'Tanggal mulai',
  'budget.filterEndDate': 'Tanggal akhir',
  'budget.totalAmount': 'Uang Jumlah yang diberikan',
  'budget.mainAmountLabel': 'Uang Diberikan',
  'budget.subAmountLabel': 'Jumlah tambahan',
  'budget.spent': 'Dihabiskan',
  'budget.remaining': 'Tersisa',
  'budget.badgeLocked': 'Telah mengunci penyelesaian',
  'budget.badgeSettled': 'Mapan',
  'budget.timeLabel': 'Waktu: {{value}}',
  'budget.edit': 'Sunting',
  'budget.editAria': 'Edit Uang yang Diberikan {{start}} ke {{end}}',
  'budget.mergedChildCount': 'Termasuk {{count}} item Uang Tambahan',
  'budget.expandChildrenAria': 'Perluas detail Uang Tambahan untuk {{start}} hingga {{end}}',
  'budget.collapseChildrenAria': 'Ciutkan detail Uang Tambahan untuk {{start}} hingga {{end}}',
  'budget.backList': 'Kembali ke daftar Uang yang Diberikan',
  'budget.loadError': 'Tidak dapat memuat Uang yang Diberikan',
  'budget.saveError': 'Gagal menyimpan',
  'budget.form.createTitle': 'Uang Baru Diberikan',
  'budget.form.editTitle': 'Edit Uang Periode yang diberikan',
  'budget.form.startDate': 'Tanggal mulai',
  'budget.form.endDate': 'Tanggal akhir',
  'budget.form.amount': 'Uang Jumlah yang diberikan',
  'budget.form.amountHint': 'Harus nol atau positif; desimal diperbolehkan.',
  'budget.form.submitCreate': 'Ciptakan Uang yang Diberikan',
  'budget.form.submitEdit': 'Simpan perubahan',
  'budget.form.saving': 'Penghematan…',
  'budget.form.cancel': 'Membatalkan',
  'budget.form.remove': 'Menghapus',
  'budget.form.removeAria': 'Hapus periode Uang Diberikan ini',
  'budget.form.removeConfirm': 'Menghapus',
  'budget.form.removing': 'Menghapus…',
  'budget.removeConfirmTitle': 'Hapus Uang yang Diberikan ini?',
  'budget.removeConfirmBody': 'Hapus Periode Uang yang Diberikan ini? Hal ini tidak dapat dibatalkan.',
  'budget.removeConfirmReceiptsExtra': '{{count}} tanda terima ditautkan ke periode Pemberian Uang ini; menghapusnya akan menghapus tautan itu.',
  'budget.removeError': 'Tidak dapat menghapus Uang yang Diberikan',
  'budget.validation.rangeRequired': 'Silakan masukkan tanggal mulai dan berakhir',
  'budget.validation.dates': 'Tanggal akhir tidak boleh sebelum tanggal mulai',
  'budget.validation.amount': 'Masukkan jumlah yang valid (nol atau positif)',
  'budget.lockedEditHint': 'Uang yang Diberikan ini terikat pada penyelesaian yang terkunci. Jika Anda memperpendek rentang tanggal, setiap tanda terima yang ditautkan harus tetap berada dalam rentang yang baru. Penyimpanan akan gagal jika tanggal penerimaan berada di luar kisaran baru atau tumpang tindih dengan periode penyelesaian lainnya; menyelesaikan penerimaan atau pelunasan terlebih dahulu jika diperlukan.',
  'budget.summaryReceipts': 'Uang yang Diberikan ini memiliki {{count}} tanda terima tertaut',
  'settlement.title': 'Penyelesaian & penguncian',
  'settlement.employerFinanceTitle': 'Pemberian Uang & Penyelesaian',
  'settlement.employerFinanceTitleMenuAria': 'Menu Pemberian Uang & Penyelesaian',
  'settlement.employerFinanceMenuPendingReviewList': 'Penyelesaian menunggu peninjauan',
  'settlement.employerFinanceMenuReceiptList': 'Daftar tanda terima',
  'settlement.formTitle': 'Pemukiman baru',
  'settlement.subtitle': 'Pilih periode. Total mencakup semua penerimaan dalam rentang versus jumlah Uang yang Diterima yang sesuai. Mengunci akan membekukan tanda terima dalam rentang tersebut.',
  'settlement.navLink': 'Penyelesaian biaya',
  'settlement.budgetLabel': 'Periode Uang Diterima',
  'settlement.startDate': 'Tanggal mulai',
  'settlement.endDate': 'Tanggal akhir',
  'settlement.preview': 'Pratinjau total',
  'settlement.previewing': 'Menghitung…',
  'settlement.totalSpent': 'Jumlah yang Dibelanjakan',
  'settlement.dailyDetail': 'Perincian',
  'settlement.dailyDetailOpen': 'Buka perincian pengeluaran harian',
  'settlement.dailyDetailTitle': 'Rincian pengeluaran harian',
  'settlement.dailyDetailDate': 'Tanggal',
  'settlement.dailyDetailReceiptCount': 'Jumlah tanda terima',
  'settlement.dailyDetailAmount': 'Jumlah',
  'settlement.budgetAmount': 'Uang Diberikan',
  'settlement.submittedAtLabel': 'Dikirim pada',
  'settlement.balance': 'Hasil Penyelesaian',
  'settlement.surplus': 'Kelebihan',
  'settlement.overspent': 'Menghabiskan uang terlalu banyak',
  'settlement.confirm': 'Konfirmasikan penyelesaian & kunci',
  'settlement.confirming': 'Pengolahan…',
  'settlement.success': 'Pemukiman terkunci',
  'settlement.error': 'Ada yang tidak beres',
  'settlement.listTitle': 'Sejarah pemukiman',
  'settlement.employerFinanceTabsAria': 'Uang Pengusaha Diberikan dan tab penyelesaian',
  'settlement.employerTabBudget': 'Uang Diberikan',
  'settlement.employerTabSettlement': 'Hunian',
  'settlement.employerSubTabReceipts': 'Daftar tanda terima',
  'settlement.filterStartDate': 'Tanggal mulai',
  'settlement.filterEndDate': 'Tanggal akhir',
  'settlement.employerFilterToDateOptional': 'Tanggal akhir (opsional)',
  'settlement.empty': 'Belum ada pemukiman',
  'settlement.locked': 'Ditinjau',
  'settlement.unlocked': 'Tidak terkunci',
  'settlement.status.submitted': 'Peninjauan tertunda',
  'settlement.status.unsettled': 'Gelisah',
  'settlement.status.settled': 'Mapan',
  'settlement.unsettledEmployerSavedReceiptNotice': 'Pembantu anda belum menyerahkan penyelesaian untuk tanggal ini, dan tanda terimanya belum diserahkan secara resmi. Pembantu Anda masih dapat mengubah konten tanda terima.',
  'settlement.givenVsExpensesTitle': 'Uang yang Diberikan vs Pengeluaran',
  'settlement.givenVsExpensesSubtitle': 'Ikhtisar 4 periode Uang Diberikan terakhir',
  'settlement.givenVsExpensesGiven': 'Diberikan',
  'settlement.givenVsExpensesSpent': 'Dihabiskan',
  'settlement.givenVsExpensesPendingSpent': 'Tertunda habis',
  'settlement.helperReceivedVsExpensesTitle': 'Uang Diterima vs Pengeluaran',
  'settlement.helperReceivedVsExpensesSubtitle': 'Ikhtisar 4 periode Uang Diterima terakhir',
  'settlement.reviewNow': 'Tinjau sekarang',
  'settlement.pendingReviewPageTitle': 'Penyelesaian menunggu peninjauan',
  'settlement.historyEventAtLabel': 'Waktu status',
  'settlement.historyViewDetailAria': 'Lihat detail riwayat penyelesaian',
  'settlement.historyDetailButton': 'Detil',
  'settlement.pastSettlementHistoryTitle': 'Sejarah pemukiman masa lalu',
  'settlement.historyStatus.withdrawn': 'Pembantu ditarik',
  'settlement.historyStatus.rejected': 'Majikan ditolak',
  'settlement.historyStatus.unlocked': 'Majikan tidak terkunci',
  'settlement.status.reviewed': 'Ditinjau',
  'settlement.status.rejected': 'Ditolak',
  'settlement.status.withdrawn': 'Ditarik',
  'settlement.recordStatusFilterAria': 'Filter pemukiman berdasarkan status',
  'settlement.recordStatusFilter.submitted': 'Tertunda',
  'settlement.recordStatusFilter.reviewed': 'Ditinjau',
  'settlement.recordStatusFilter.rejected': 'Ditolak',
  'settlement.recordStatusFilter.withdrawn': 'Ditarik',
  'settlement.recordStatusFilter.unlocked': 'Tidak terkunci',
  'settlement.lockHint': 'Pengeluaran untuk tanggal-tanggal ini telah diselesaikan dan dikunci. Minta perusahaan Anda untuk membuka kunci penyelesaian tersebut di aplikasi sebelum Anda dapat mengedit atau menghapus tanda terima pada periode ini.',
  'settlement.detailTitle': 'Detail pemukiman',
  'settlement.detailTitleMenuAria': 'Menu detail penyelesaian',
  'settlement.menuEditMoneyGiven': 'Sunting uang yang diberikan',
  'settlement.menuAppendMoneyGiven': 'Tambahkan uang yang diberikan',
  'settlement.unlock': 'Buka kunci penyelesaian',
  'settlement.withdraw': 'Menarik pengajuan penyelesaian',
  'settlement.reviewedAction': 'Tandai sebagai telah ditinjau',
  'settlement.rejectReasonPrompt': 'Silakan masukkan alasan penolakan',
  'settlement.rejectModalTitle': 'Tolak penyelesaian ini',
  'settlement.unlockConfirmTitle': 'Buka kunci penyelesaian?',
  'settlement.unlockConfirmBody': 'Setelah membuka kunci, pembantu dapat mengedit tanda terima dalam rentang tanggal ini. Tindakan ini dicatat dalam log audit.',
  'settlement.unlocking': 'Membuka kunci…',
  'settlement.unlockSuccess': 'Tidak terkunci',
  'settlement.auditTitle': 'Buka kunci riwayat',
  'settlement.auditEmpty': 'Belum ada acara buka kunci',
  'settlement.receiptsTitle': 'Penerimaan dalam jangkauan',
  'settlement.viewReceipt': 'Lihat tanda terima',
  'settlement.noBudgets': 'Anda dapat mengunggah kuitansi dan menyelesaikannya tanpa menyiapkan Uang Diberikan terlebih dahulu; jika tidak ada periode pencocokan, total Uang yang Diterima dianggap 0.',
  'settlement.employerNoBudgetsBanner': 'Belum Ada Uang Diberikan periodenya. Pemukiman masih berfungsi; pertimbangkan untuk menambahkan Uang Diberikan untuk kejelasan.',
  'settlement.selectRange': 'Silakan pilih tanggal mulai dan berakhir',
  'settlement.confirmLockModalTitle': 'Kirim penyelesaian ini ke majikan?',
  'settlement.confirmEmptyModalTitle': 'Tidak ada tanda terima dalam rentang ini',
  'settlement.confirmLockPrompt': 'Konfirmasikan untuk mengirimkan penyelesaian {{start}} - {{end}}? Tanda terima dalam rentang tersebut tidak dapat diedit dan diunggah.',
  'settlement.confirmEmptyReceiptsPrompt': 'Tidak ada tanda terima dalam kisaran ini. Tetap kirimkan?',
  'settlement.previewFirst': 'Pratinjau belum siap. Tunggu total dimuat atau sesuaikan tanggal sebelum mengunci.',
  'settlement.budgetAmountHint': 'Jumlah periode utama dan seluruh jumlah Uang Tambahan.',
  'settlement.helperHeroTitle': 'Biaya & penyelesaian',
  'settlement.helperHeroSubtitle': 'Kelola pengeluaran Anda dan serahkan ke majikan Anda.',
  'settlement.helpPopoverTriggerAria': 'Lihat langkah penyelesaian dan catatan',
  'settlement.helpPopoverAria': 'Langkah penyelesaian dan catatan',
  'settlement.helpPopoverTitle': 'Cara mengirim penyelesaian',
  'settlement.helpPopoverStep1': 'Pindai dan simpan semua tanda terima untuk periode penyelesaian.',
  'settlement.helpPopoverStep2':
    'Di halaman ini, pilih periode Uang Diterima dan pratinjau pengeluaran.',
  'settlement.helpPopoverStep3': 'Ketuk Setuju & Selesaikan untuk dikirim ke majikan.',
  'settlement.helpPopoverNotesHeading': 'Catatan',
  'settlement.helpPopoverNote1':
    'Setelah menyimpan tanda terima, Anda harus mengirim penyelesaian agar majikan meninjau.',
  'settlement.helpPopoverNote2':
    'Setelah dikirim, Anda tidak dapat mengunggah atau mengedit tanda terima untuk tanggal tersebut hingga majikan menolak, membuka kunci, atau Anda menarik.',
  'settlement.helperQuickActions': 'Tindakan cepat',
  'settlement.helperActionScanTitle': 'Pindai tanda terima',
  'settlement.helperActionScanMeta': 'Ekstrak AI dan kirimkan',
  'settlement.helperActionReceiptListTitle': 'Daftar tanda terima',
  'settlement.helperActionReceiptListMeta': 'Lihat tanda terima yang dikirimkan dan tertunda',
  'settlement.helperActionLockTitle': 'Setuju & Selesaikan',
  'settlement.helperActionLockMeta': 'Kunci rentang yang dipilih dan kirimkan ke perusahaan',
  'settlement.helperActionHistoryTitle': 'Sejarah pemukiman',
  'settlement.helperActionHistoryMeta': 'Lihat catatan penyelesaian masa lalu',
  'settlement.helperDateRangeAria': 'Periode penyelesaian yang dipilih; perluas untuk mengubah tanggal',
  'settlement.helperStatPeriodBudget': 'Uang Diterima',
  'settlement.moneyReceivedDetailOpen': 'Buka uang yang diterima rinciannya',
  'settlement.moneyReceivedDetailTitle': 'Detail Uang Diterima',
  'settlement.moneyReceivedDetailReceivedDate': 'Waktu',
  'settlement.moneyReceivedDetailPeriod': 'Periode',
  'settlement.moneyReceivedDetailAmount': 'Jumlah',
  'settlement.moneyReceivedDetailAddOn': 'Tambahan',
  'settlement.moneyGivenDetailOpen': 'Buka Uang Diberikan rincian',
  'settlement.moneyGivenDetailTitle': 'Detail Uang Diberikan',
  'settlement.helperStatTotalSpent': 'Jumlah yang dibelanjakan',
  'settlement.helperStatBalance': 'Keseimbangan',
  'settlement.dailyBreakdownVsBudgetTitle': 'Pembelanjaan harian',
  'settlement.dailyBudgetAmount': 'Uang Harian Menerima rincian',
  'settlement.dailyVsBudgetColBudget': 'Uang Diterima',
  'settlement.dailyVsBudgetColExpense': 'Membelanjakan',
  'settlement.dailyBudgetVariance': 'Beda.',
  'settlement.expensePreview': 'Pratinjau biaya',
  'settlement.breakdownModalTitle': 'Rincian pengeluaran harian',
  'settlement.openBreakdownAria': 'Perincian Terbuka: jumlah dan jumlah penerimaan harian',
  'settlement.helperConfirmDateRangeLabel': 'Rentang tanggal penyelesaian',
  'settlement.helperConfirmDateRangeSeparator': 'ke',
  'settlement.helperConfirmLockNotice': 'Setelah pelunasan, catatan pengeluaran untuk periode ini akan dikunci. Majikan Anda harus membuka kuncinya sebelum Anda dapat mengeditnya lagi.',
  'settlement.helperConfirmPrimary': 'Kirim',
  'settlement.helperSettleButton': 'Setuju & Selesaikan',
  'settlement.confirmAction': 'Mengonfirmasi',
  'settlement.helperReviewedByEmployerNotice': 'Majikan Anda telah meninjau penyelesaian ini.',
  'settlement.helperSubmittedNotice': 'Penyelesaian yang diajukan sudah ada dalam rentang tanggal ini dan menunggu tinjauan pemberi kerja.',
  'settlement.helperSubmittedRangeNotice': 'Penyelesaian yang diajukan sudah ada dalam rentang tanggal ini ({{range}}) dan menunggu tinjauan pemberi kerja.',
  'settlement.helperSubmittedRangesNotice': 'Penyelesaian yang diajukan sudah ada dalam rentang tanggal ini ({{ranges}}) dan menunggu tinjauan pemberi kerja.',
  'settlement.helperSubmittedAndReviewedRangesNotice': 'Penyelesaian yang diserahkan/ditinjau sudah ada dalam rentang tanggal ini ({{ranges}}). Item yang dikirimkan sedang menunggu tinjauan pemberi kerja.',
  'settlement.confirmOverlapSubmittedRangesError': 'Tanggal yang dipilih tumpang tindih dengan penyelesaian yang diajukan ({{ranges}}). Harap tarik data tersebut atau tunggu tinjauan perusahaan sebelum mengirimkan tanggal yang tumpang tindih.',
  'settlement.confirmOverlapLockedRangesError': 'Tanggal yang dipilih tumpang tindih dengan periode penyelesaian yang terkunci ({{ranges}}). Minta perusahaan Anda untuk membuka kuncinya sebelum mengirimkan tanggal yang tumpang tindih.',
  'settlement.helperConfirmPageTitle': 'Setuju & Selesaikan',
  'settlement.helperConfirmSubtitle': 'Tinjau total untuk periode yang dipilih, lalu kunci dan kirimkan ke perusahaan Anda.',
  'settlement.helperHistoryPageTitle': 'Sejarah pemukiman',
  'settlement.helperHistoryTabBySettlement': 'Dengan penyelesaian',
  'settlement.helperHistoryTabByMoneyReceived': 'Dengan uang yang diterima',
  'settlement.helperHistoryViewTabsAria': 'Tampilan riwayat pemukiman',
  'settlement.helperResubmitBannerPrefix': 'Tidak ada penyelesaian terkini yang diajukan untuk periode ini. Mengetuk',
  'settlement.helperResubmitBannerLink': 'Di Sini',
  'settlement.helperResubmitBannerSuffix': 'untuk mengirimkan.',
  'settlement.helperResubmitBannerLinkAria': 'Pergi ke Setuju & Selesaikan',
  'settlement.helperBackToExpenses': 'Kembali ke pengeluaran & penyelesaian',
  'settlement.totalSpentReceiptHint': 'Termasuk tanda terima yang disimpan, diserahkan, dan ditinjau.',
  'settlement.period': '{{start}} – {{end}}',
  'settlement.backList': 'Kembali ke pemukiman',
  'apiError.settlementLockedReceipt': 'Tanggal penerimaan ini ({{receiptDate}}) berada dalam periode yang telah diselesaikan dan dikunci ({{start}} hingga {{end}}). Minta perusahaan Anda untuk membuka kunci penyelesaian itu di aplikasi; lalu Anda dapat menambah, mengedit, atau menghapus kuitansi untuk tanggal tersebut.',
  'apiError.settlementRangeOverlapsLocked': 'Tanggal yang Anda pilih ({{reqStart}} hingga {{reqEnd}}) tumpang tindih dengan periode yang telah diselesaikan dan dikunci ({{start}} hingga {{end}}). Minta majikan Anda untuk membuka penyelesaian tersebut terlebih dahulu, atau pilih tanggal yang tidak tumpang tindih.',
  'apiError.settlementNoReceiptsAck': 'Tidak ada tanda terima dalam rentang tanggal ini. Jika Anda masih ingin mengunci periode kosong, konfirmasikan terlebih dahulu menggunakan opsi di layar.',
  'apiError.budgetOverlapsSettlement': 'Periode Pemberian Uang ini tumpang tindih dengan tanggal-tanggal yang sudah termasuk dalam penyelesaian yang ada. Pilih tanggal yang sepenuhnya berada di luar setiap periode penyelesaian.',
  'apiError.budgetShrinkReceiptsOutside': 'Tanggal-tanggal ini terlalu sempit: satu atau lebih tanda terima yang ditautkan memiliki tanggal di luar rentang yang baru. Perluas tanggal Pemberian Uang atau sesuaikan terlebih dahulu penerimaannya.',
  'apiError.budgetDeleteLocked': 'Uang yang Diberikan ini tidak dapat ditarik kembali karena memiliki penyelesaian yang terkunci. Selesaikan penyelesaiannya terlebih dahulu.',
  'apiError.budgetMainOverlap': 'Periode Pemberian Uang ini tumpang tindih dengan periode yang ada: {{ranges}}. Harap pilih rentang tanggal yang tidak tumpang tindih.',
  'apiError.subBudgetOutOfMainRange': 'Periode Uang Tambahan harus sepenuhnya berada dalam periode utama yang dipilih.',
  'apiError.mainBudgetLockedBySubmittedSettlement': 'Periode Uang yang Diberikan ini memiliki penyelesaian yang diserahkan dan sekarang hanya dapat dibaca. Anda tidak dapat mengedit atau menghapusnya.',
  'apiError.receiptDeleteStatusNotAllowed': 'Tanda terima ini tidak dapat dihapus dalam statusnya saat ini. Hanya tanda terima yang menunggu untuk ditinjau, ditandai perlu diperbarui, atau dibatalkan yang dapat dihapus.',
  'apiError.receiptUpdateStatusNotAllowed': 'Tanda terima ini tidak dapat diedit saat ini. Anda hanya dapat mengedit tanda terima yang menunggu tinjauan perusahaan atau yang diminta oleh perusahaan untuk Anda perbarui.',
  'apiError.settlementAlreadyUnlocked': 'Penyelesaian ini sudah terbuka. Refresh halaman untuk melihat status terbaru.',
  'translation.autoTranslatedTo': 'Otomatis diterjemahkan ke {{language}}. Terjemahan mungkin salah.',
  'translation.showOriginal': 'Tampilkan asli',
  'translation.showTranslated': 'Tampilkan terjemahan',
  'translation.hintButtonAria': 'Info terjemahan',
  'translation.hintPanelAria': 'Petunjuk terjemahan otomatis',
  'translation.lang.zhHant': 'Bahasa Tionghoa Tradisional',
  'translation.lang.zhHans': 'Bahasa Tionghoa Sederhana',
  'translation.lang.en': 'Bahasa Inggris',
  'translation.lang.id': 'Bahasa Indonesia',
  'translation.lang.fil': 'Bahasa Filipina',
  'family.navLink': 'Anggota keluarga',
  'family.title': 'Preferensi Anggota Keluarga',
  'family.subtitle': 'Pengusaha dapat menambah atau mengedit; kedua belah pihak dapat melihatnya.',
  'family.listConsentLabel': 'Saya mengonfirmasi bahwa anggota keluarga telah menyetujui untuk membagikan data mereka.',
  'family.listConsentHint': 'Centang kotak di atas untuk melihat atau mengelola data anggota keluarga.',
  'family.addMember': 'Tambahkan anggota',
  'family.addMemberAria': 'Tambahkan anggota keluarga',
  'family.editMember': 'Sunting',
  'family.editMemberAria': 'Sunting anggota keluarga',
  'family.deleteMember': 'Menghapus',
  'family.deleteConfirm': 'Hapus anggota keluarga ini? Hal ini tidak dapat dibatalkan.',
  'family.empty': 'Belum ada anggota keluarga',
  'family.emptyHint': 'Ketuk “Tambahkan anggota” untuk menambahkan anggota.',
  'family.emptyHintHelper': 'Hanya majikan yang dapat menambah anggota keluarga. Hubungi majikan Anda jika diperlukan.',
  'family.field.name': 'Nama',
  'family.field.nickname': 'Nama panggilan',
  'family.formField.nickname': 'Nama panggilan (opsional)',
  'family.formField.birthday': 'Ulang tahun (opsional)',
  'family.formField.remark': 'Aktivitas rutin (opsional)',
  'family.formField.foodPreference': 'Preferensi makanan (opsional)',
  'family.formField.foodAllergy': 'Alergi makanan (opsional)',
  'family.formField.medicalCondition': 'Kondisi medis (opsional)',
  'family.formField.hashtags': 'Tag (opsional)',
  'family.placeholder.name': 'misalnya Ben Chan',
  'family.placeholder.nickname': 'misalnya kakak',
  'family.placeholder.foodPreference': 'misalnya makanan ringan, seperti apel',
  'family.placeholder.foodAllergy': 'misalnya kacang tanah',
  'family.placeholder.medicalCondition': 'misalnya darah tinggi, minum obat setiap hari',
  'family.placeholder.hashtags': 'misalnya diet ringan, rendah garam',
  'family.field.birthday': 'Hari ulang tahun',
  'family.field.age': 'Usia',
  'family.field.foodPreference': 'Preferensi makanan',
  'family.field.foodAllergy': 'Alergi makanan',
  'family.field.medicalCondition': 'Kondisi medis',
  'family.field.remark': 'Kegiatan rutin',
  'family.field.remarkPlaceholder': 'misalnya Kelas sepak bola - Sabtu jam 10 pagi',
  'family.field.hashtags': 'Tag',
  'family.field.hashtagsHint': 'Masukkan beberapa tag yang dipisahkan dengan koma, titik koma, atau baris baru.',
  'family.birthday.optionalHint': 'Opsional. Anda boleh mengosongkan tahun dan hanya memilih bulan dan hari.',
  'family.birthday.exampleHint': 'misalnya tahun 2011, bulan 03, hari ke 15; atau pilih bulan dan hari saja (kosongkan tahunnya).',
  'family.birthday.yearOptional': 'Tahun (opsional)',
  'family.birthday.month': 'Bulan',
  'family.birthday.day': 'Hari',
  'family.display.birthdaySkipped': 'Tidak ada ulang tahun yang tercatat',
  'family.display.ageWithYear': '{{age}} tahun (lahir pada {{year}})',
  'family.display.birthdayMonthDay': '{{month}}/{{day}}',
  'family.validation.birthdayNeedMonthDay': 'Untuk menambahkan tanggal lahir, pilih bulan dan hari.',
  'family.validation.birthdayInvalid': 'Ulang tahun itu tidak sah. Periksa tahun, bulan, dan hari.',
  'family.formConsentLabel': 'Saya mengonfirmasi bahwa orang ini telah menyetujui untuk membagikan datanya.',
  'family.formCreateTitle': 'Tambahkan anggota keluarga',
  'family.formEditTitle': 'Sunting anggota keluarga',
  'family.formSubmit': 'Menyimpan',
  'family.formSubmitting': 'Penghematan…',
  'family.formCancel': 'Membatalkan',
  'family.loadError': 'Tidak dapat memuat anggota keluarga',
  'family.saveError': 'Gagal menyimpan',
  'family.deleteError': 'Penghapusan gagal',
  'family.validation.consentRequired': 'Harap konfirmasi persetujuan sebelum menyimpan.',
  'inventory.title': 'Tugas Stok Rumah',
  'inventory.subtitle': 'Tambahkan foto secara berkelompok (satu foto dapat mencakup banyak item), AI mencocokkan daftar periksa Anda, lalu menambahkan foto atau mengonfirmasi secara manual sebelum mengirimkan',
  'inventory.stocktakePanelTitle': 'Foto inventarisasi',
  'inventory.stocktakePanelHint': 'Satu gambar mungkin menampilkan beberapa item daftar.',
  'inventory.stocktakeMaxFilesHint': 'Hingga 10 gambar sekaligus',
  'inventory.uploadedStocktakePhotosHeading': 'Foto Stok Beranda yang diunggah',
  'inventory.uploadedStocktakePhotoAlt': 'Foto Stok Rumah {{n}}',
  'inventory.enlargePhotoAria': 'Lihat foto Stok Rumah ukuran penuh',
  'inventory.removePhotoAria': 'Hapus foto Stok Rumah ini',
  'inventory.removeStocktakePhotoTitle': 'Hapus foto ini?',
  'inventory.removeStocktakePhotoDescription': 'Anda dapat menghapus foto sebelum dikirimkan. Jika ada garis yang menggunakan gambar ini untuk AI, garis tersebut akan dihapus—tambahkan foto baru atau atur level secara manual.',
  'inventory.removeStocktakePhotoConfirm': 'Menghapus',
  'inventory.notRecognizedByAi': 'Setelah setidaknya satu foto diunggah, garis-garis tersebut masih belum dicocokkan oleh AI. Tambahkan foto lain atau pilih tingkat stok di bawah (mereka dapat berbagi foto batch yang sama saat Anda mengirimkannya).',
  'inventory.matchedByAiHint': 'Diisi oleh AI (bisa diubah)',
  'inventory.stockLevel': 'Tingkat stok',
  'inventory.stockLevelRequired': 'Pilih tingkat stok untuk setiap item daftar.',
  'inventory.level.full': 'Penuh',
  'inventory.level.half': 'Setengah',
  'inventory.level.low': 'Rendah',
  'inventory.level.empty': 'Kosong',
  'inventory.level.unknown': '—',
  'inventory.photoLabel': 'Foto barang',
  'inventory.analyze': 'Analisis AI',
  'inventory.analyzing': 'Menganalisis…',
  'inventory.stocktakeUploading': 'Mengunggah…',
  'inventory.stocktakeUploadingProgress': 'Mengunggah {{current}} / {{total}}',
  'inventory.analyzeNeedPhoto': 'Pilih foto sebelum menganalisis',
  'inventory.analyzeError': 'Analisis gagal. Coba lagi.',
  'inventory.stocktakeDailyAiLimitPhotoSaved': 'Kuota gambar AI harian Anda habis (dibagikan dengan pemindaian tanda terima). Tidak ada AI yang dijalankan untuk unggahan ini. Jika pengunggahan ke awan berhasil, thumbnail tetap ada dalam daftar—masukkan tingkat stok secara manual; kuota direset pada hari UTC berikutnya.',
  'inventory.needAtLeastOneBatchPhoto': 'Unggah setidaknya satu foto Stok Beranda.',
  'inventory.needPhotoBeforeStockLevels': 'Unggah setidaknya satu foto Stok Rumah untuk lokasi ini terlebih dahulu. Level stok, kadaluwarsa, dan entri item manual muncul setelah itu.',
  'inventory.unmatchedUseSharedPhotoHint': 'Jika kumpulan ini sudah memiliki gambar yang diunggah, baris yang tidak dikenal akan membagikan tautan yang sama saat Anda mengirimkannya; Anda tidak memerlukan foto terpisah untuk setiap baris.',
  'inventory.emptyTemplate': 'Daftar periksa ini tidak memiliki item dan tidak dapat dikirimkan',
  'inventory.helperOnly': 'Hanya pembantu yang dapat melakukan inventarisasi',
  'inventory.chainBlockedBanner': 'Stok rumah sebelumnya masih menunggu review, jadi tugas stok rumah ini dikunci untuk saat ini.',
  'inventory.wizard.locationStepBadge': 'Lokasi {{current}} dari {{total}}: {{name}}',
  'inventory.wizard.reviewPhaseHint': 'Tinjauan: konfirmasi waktu penyelesaian, lalu kirimkan',
  'inventory.wizard.reviewTitle': 'Ringkasan berdasarkan lokasi',
  'inventory.wizard.reviewLocationSummaryPhotos': '{{photos}} foto',
  'inventory.wizard.reviewLocationSummaryEmptyCategories': '{{noCat}} kategori ditandai kosong',
  'inventory.wizard.noItemsHeading': 'Tidak ada item untuk kategori ini di lokasi ini',
  'inventory.wizard.noItemsHint': 'Jika suatu kategori benar-benar tidak memiliki item di sini, centang untuk mengonfirmasi (tidak diperlukan tingkat stok).',
  'inventory.wizard.noItemsHintTickFirst': 'Telusuri setiap kategori perusahaan terlebih dahulu: centang di bawah jika sebenarnya tidak ada apa pun di sini untuk kategori tersebut; baru kemudian isi baris stok dan kadaluarsa untuk item yang terdeteksi atau ditambahkan secara manual.',
  'inventory.wizard.noItemsConfirmModalTitle': 'Konfirmasikan kategori kosong',
  'inventory.wizard.noItemsConfirmModalDescription': 'Kategori ini tidak memiliki item yang dihitung di lokasi ini. Centang setiap baris konfirmasi, lalu tekan Konfirmasi untuk melanjutkan.',
  'inventory.wizard.noItemCategoryAria': 'Tidak ada item untuk kategori “{{category}}” di lokasi ini',
  'inventory.wizard.noItemCategoryLabel': 'Tidak ada item untuk kategori “{{category}}” di lokasi ini',
  'inventory.wizard.rowSkippedNoItemsCategory': 'Kategori baris ini ditandai karena tidak ada item di lokasi ini.',
  'inventory.wizard.manualItemNoItemsCategoryBanner': 'Kategori ini ditandai sebagai “tidak ada item jenis ini di lokasi ini.” Anda masih dapat memasukkan stok dan kadaluwarsa di sini; untuk memasukkannya ke dalam kiriman Anda, kosongkan tanda itu terlebih dahulu.',
  'inventory.wizard.continueNextLocation': 'Lanjutkan ke lokasi berikutnya',
  'inventory.wizard.goToReview': 'Pergi ke ulasan',
  'inventory.wizard.photoRequiredPerLocation': 'Unggah setidaknya satu foto inventarisasi untuk setiap lokasi.',
  'inventory.wizard.noItemsConflict': 'Anda menandai kategori ini sebagai tidak memiliki item; menghapus tingkat stok untuk baris tersebut.',
  'inventory.wizard.categoryMarkNoItems': 'Kategori “{{category}}” tidak memiliki baris daftar yang cocok; tandai “tidak ada item untuk kategori ini”.',
  'inventory.wizard.helperSingleStep1Badge': 'Langkah 1/2: ambil atau unggah foto Stok Beranda',
  'inventory.wizard.helperSingleStep2Badge': 'Langkah 2/2: masukkan level stok dan kadaluwarsa',
  'inventory.wizard.continueToStockEntry': 'Berikutnya: masukkan detail stok',
  'inventory.wizard.locationHubTitle': 'Lokasi',
  'inventory.wizard.locationHubHint': 'Bekerja di lokasi mana pun dalam urutan apa pun — ketuk kartu untuk beralih. Setiap lokasi memerlukan setidaknya satu foto ditambah kategori/aturan inventarisasi yang telah dilengkapi sebelum Anda dapat mengirimkan ringkasannya.',
  'inventory.wizard.locationHubReviewHint': 'Periksa setiap lokasi terlihat benar. Ketuk “Lanjutkan mengedit lokasi ini” untuk kembali saat Anda memerlukan perubahan.',
  'inventory.wizard.locationHubProgress': 'Siap dikirim: {{done}} / {{total}} lokasi',
  'inventory.wizard.locationHubSelectAria': 'Beralih ke {{name}}',
  'inventory.wizard.locationHubCurrentBadge': 'Mengedit',
  'inventory.wizard.locationHubStatusPhotoOk': 'Foto ditambahkan',
  'inventory.wizard.locationHubStatusPhotoMissing': 'Foto hilang',
  'inventory.wizard.locationHubStatusReady': 'Semua bidang yang wajib diisi OK',
  'inventory.wizard.locationHubStatusIncomplete': 'Masih belum lengkap',
  'inventory.wizard.editLocationFromReview': 'Lanjutkan mengedit lokasi ini',
  'inventory.wizard.editLocationFromReviewAria': 'Kembali mengedit {{name}}',
  'inventory.wizard.notAllLocationsReady': 'Beberapa lokasi masih belum lengkap — gunakan “Lokasi” untuk berpindah dan menyelesaikan bidang foto, kategori, dan inventarisasi (pembaruan kemajuan jika sudah siap).',
  'inventory.wizard.selectLocationTitle': 'Pilih lokasi',
  'inventory.wizard.selectLocationSubtitle': 'Pilih lokasi untuk memulai penghitungan inventaris Anda.',
  'inventory.wizard.hubInfoBanner': 'Selesaikan setiap lokasi yang ditugaskan sebelum Anda dapat mengirimkan.',
  'inventory.wizard.hubLocationsCompleted': '{{done}} / {{total}} lokasi selesai',
  'inventory.wizard.tapToStart': 'Ketuk untuk memulai',
  'inventory.wizard.locationCompletedLine': 'Selesai',
  'inventory.wizard.locationHubStatusInProgress': 'Diperlukan lebih banyak detail',
  'inventory.wizard.locationHubStatusNeedsStock': 'Pilih tingkat stok untuk item',
  'inventory.wizard.locationHubStatusNeedsExpiry': 'Pilih opsi kedaluwarsa untuk item',
  'inventory.wizard.locationHubStatusNeedsCategories': 'Ketuk Lanjutkan pada Tinjau item untuk mengonfirmasi kategori kosong',
  'inventory.wizard.hubNextStep': 'Langkah selanjutnya',
  'inventory.wizard.hubNextDisabledHint': 'Selesaikan semua lokasi sebelum melanjutkan.',
  'inventory.wizard.stepBadge': 'Langkah {{current}} / {{total}}',
  'inventory.wizard.stepBadgeWithSubstep': 'Langkah {{major}}{{sub}} / {{total}}',
  'inventory.wizard.stepBadgeWithSubstepAria': 'Langkah saat ini {{major}}{{sub}} dari {{total}}',
  'inventory.wizard.selectLocationIncompleteSection': 'Tidak lengkap',
  'inventory.wizard.selectLocationCompleteSection': 'Selesai',
  'inventory.wizard.selectLocationModalCloseAria': 'Tutup pemilih lokasi',
  'inventory.wizard.selectLocationFinalReviewButton': 'Ulasan akhir',
  'inventory.wizard.leaveHomeStockWorkButton': 'Tinggalkan Pekerjaan Stok Rumah',
  'inventory.wizard.viewThisTaskButton': 'Lihat tugas ini',
  'inventory.wizard.leaveHomeStockWorkConfirmTitle': 'Tinggalkan Rumah Stok bekerja?',
  'inventory.wizard.leaveHomeStockWorkConfirmDescription': 'Apa pun yang belum Anda kirimkan tidak akan disimpan. Kembali ke daftar tugas Hari Ini?',
  'inventory.wizard.progressAria': 'Kemajuan sekitar {{percent}} persen',
  'inventory.wizard.photosStepTitle': 'Ambil foto',
  'inventory.wizard.photosStepSubtitle': 'Ambil atau unggah foto Home Stock untuk {{location}}.',
  'inventory.wizard.reviewItemsTitle': 'Tinjau item',
  'inventory.wizard.reviewItemsSubtitle': 'Verifikasi item dan perbarui statusnya.',
  'inventory.wizard.continueToReviewItems': 'Lanjutkan meninjau item',
  'inventory.wizard.continueWithAiAnalyze': 'AI menganalisis & meninjau item ⮕',
  'inventory.wizard.continueWithoutAi': 'Tinjau item (tanpa AI) ⮕',
  'inventory.wizard.aiSelectModalTitle': 'Pilih foto untuk dianalisis',
  'inventory.wizard.aiSelectModalDescription': 'Foto yang dianalisis dan belum dianalisis dicantumkan secara terpisah. Hanya foto yang belum dianalisis yang dipilih secara default.',
  'inventory.wizard.aiSelectModalNotAnalyzedHeading': 'Belum dianalisis',
  'inventory.wizard.aiSelectModalAnalyzedHeading': 'Sudah dianalisis',
  'inventory.wizard.aiSelectModalSectionEmpty': '(tidak ada)',
  'inventory.wizard.aiSelectModalConfirm': 'Jalankan analisis AI',
  'inventory.wizard.aiSelectPhotoCheckboxAria': 'Analisis foto {{n}}',
  'inventory.wizard.reanalyzeConfirmTitle': 'Analisis ulang foto?',
  'inventory.wizard.reanalyzeConfirmDescription': 'Data untuk {{items}} item yang tertaut ke {{photos}} foto yang dipilih akan dihapus dan diganti dengan hasil AI yang baru. Item di foto lain tidak berubah.',
  'inventory.wizard.reanalyzeConfirmProceed': 'Konfirmasikan & analisis',
  'inventory.stocktakeDailyAiLimitBatchCancelled': 'Kuota AI saat ini tidak mencukupi; analisis untuk semua foto yang dipilih dibatalkan.',
  'inventory.removeStocktakePhotoWithItemsDescription': 'Foto ini tertaut ke {{count}} item. Hapus foto dan item tersebut?',
  'inventory.removeStocktakePhotoDeleteWithItems': 'Hapus foto & item tertaut',
  'inventory.removeStocktakePhotoKeepAll': 'Simpan foto & barang',
  'inventory.manualAdd.photoRequired': 'Pilih foto milik item ini.',
  'inventory.manualAdd.photoPlaceholder': 'Pilih foto',
  'inventory.itemPhotoLabel': 'Foto',
  'inventory.itemPhotoPickerAria': 'Pilih foto barang',
  'task.review.inventoryItemPhotoAria': 'Foto barang',
  'inventory.wizard.saveAndNextLocation': 'Simpan & lokasi berikutnya',
  'inventory.wizard.continueToFinalReview': 'Lanjutkan ke tinjauan akhir',
  'inventory.wizard.finalReviewTitle': 'Ulasan akhir',
  'inventory.wizard.finalReviewSubtitle': 'Verifikasi jumlah dan ringkasan Anda sebelum memberi tahu perusahaan Anda.',
  'inventory.wizard.statLowStock': 'Stok barang sedikit',
  'inventory.wizard.statExpiringSoon': 'Segera habis masa berlakunya',
  'inventory.wizard.statTotalCategories': 'Jumlah kategori',
  'inventory.wizard.statTotalPhotos': 'Jumlah foto',
  'inventory.statDetailModal.lowStockTitle': 'Stok barang sedikit',
  'inventory.statDetailModal.expiringTitle': 'Item kedaluwarsa (dalam {{days}} hari)',
  'inventory.statDetailModal.categoryLabel': 'Kategori',
  'inventory.statDetailModal.locationLabel': 'Lokasi',
  'inventory.statDetailModal.expiryHeading': 'Status kadaluwarsa',
  'inventory.statDetailModal.empty': 'Tidak ada item untuk dicantumkan.',
  'inventory.statDetailModal.closeButton': 'Menutup',
  'inventory.statDetailModal.closeAria': 'Tutup dialog detail',
  'inventory.statDetailModal.dismissBackdropAria': 'Tutup detailnya (ketuk latar belakang)',
  'inventory.statDetailModal.openLowStockAria': 'Buka detail stok rendah, {{count}} item',
  'inventory.statDetailModal.openExpiringAria': 'Buka detail masa berlaku, {{count}} item',
  'inventory.wizard.locationDetailsSection': 'Ringkasan lokasi',
  'inventory.wizard.submissionInfoSection': 'Informasi penyerahan',
  'inventory.wizard.finalReviewDateLabel': 'Tanggal',
  'inventory.wizard.finalReviewCompletionTimeLabel': 'Waktu penyelesaian',
  'inventory.wizard.readyToSubmitTitle': 'Siap untuk mengirimkan?',
  'inventory.wizard.readyToSubmitDisclaimer': 'Mengirimkan memberi tahu perusahaan Anda untuk ditinjau. Anda tidak dapat mengedit jumlah ini setelah pengiriman.',
  'inventory.wizard.sendReport': 'Kirim',
  'inventory.wizard.addItemManuallyTitle': 'Tambahkan item secara manual',
  'inventory.wizard.renameItemPrompt': 'Nama barang',
  'inventory.wizard.renameItemAria': 'Edit nama item',
  'inventory.wizard.removeManualItemTitle': 'Hapus item ini?',
  'inventory.wizard.removeManualItemDescription': 'Tindakan ini akan menghapus “{{name}}” serta data stok dan kadaluwarsanya untuk lokasi ini. Hal ini tidak dapat dibatalkan.',
  'inventory.wizard.reviewLocationBadgeAria': 'Lokasi saat ini: {{location}}',
  'inventory.wizard.editCategoryAria': 'Sunting kategori',
  'inventory.wizard.editAllLocations': 'Sunting semuanya',
  'inventory.wizard.locationItemsBadge': 'Barang',
  'inventory.wizard.reviewLocationStatItemsCaption': 'ITEM',
  'inventory.wizard.reviewLocationStatEmptyCatCaption': 'KUCING KOSONG.',
  'inventory.wizard.reviewLocationStatEmptyCatCaptionFull': 'Kategori kosong',
  'inventory.wizard.reviewLocationStatPhotosCaption': 'FOTO',
  'inventory.wizard.previewLocationResults': 'Pratinjau',
  'inventory.wizard.previewLocationResultsAria': 'Pratinjau hasil stok rumah untuk {{name}}',
  'inventory.wizard.previewLocationResultsCloseAria': 'Tutup pratinjau hasil stok rumah',
  'inventory.wizard.previewLocationResultsDismissBackdropAria': 'Tutup pratinjau hasil stok rumah (ketuk latar belakang)',
  'inventory.manualAdd.title': 'Tambahkan item secara manual',
  'inventory.manualAdd.sectionAria': 'Kategori manual dan entri item',
  'inventory.manualAdd.expandToggleAria': 'Perluas formulir tambahkan item secara manual',
  'inventory.manualAdd.collapseToggleAria': 'Ciutkan formulir penambahan item secara manual',
  'inventory.manualAdd.hint': 'Jika suatu barang hilang dari daftar inventaris atau tidak terdeteksi di foto, ketikkan kategori dan namanya. Saat pemberi kerja menentukan kategori untuk tugas ini, pilih salah satu dari daftar.',
  'inventory.manualAdd.saveToMasterHint': 'Majikan Anda memperbolehkan pembantu untuk mengedit daftar induk inventaris: ketika pembuatan berhasil, daftar tersebut juga disimpan di sana (jika gagal, item tersebut masih dapat dimasukkan dalam penyerahan ini saja).',
  'inventory.manualAdd.onlySubmissionHint': 'Jika pengeditan daftar induk inventaris dinonaktifkan: item yang Anda tambahkan di sini dikirimkan hanya dengan tugas Stok Rumah ini dan tidak ditambahkan ke daftar induk secara default.',
  'inventory.manualAdd.categoryLabel': 'Kategori',
  'inventory.manualAdd.categoryPlaceholder': 'Pilih kategori',
  'inventory.manualAdd.categoryOtherLabel': 'Kategori (jenis)',
  'inventory.manualAdd.categoryOtherPlaceholder': 'Nama kategori (hingga 120 karakter)',
  'inventory.manualAdd.itemNameLabel': 'Nama barang',
  'inventory.manualAdd.itemNamePlaceholder': 'misalnya Deterjen cucian',
  'inventory.manualAdd.addButton': 'Tambahkan barang',
  'inventory.manualAdd.adding': 'Menambahkan…',
  'inventory.manualAdd.validationBoth': 'Masukkan kategori dan nama item.',
  'inventory.manualAdd.validationCategory': 'Pilih salah satu kategori yang ditentukan untuk tugas ini.',
  'inventory.manualAdd.stockRequired': 'Pilih tingkat stok (penuh/setengah/rendah/kosong).',
  'inventory.manualAdd.expiryChoiceRequired': 'Pilih “tidak ada masa kadaluarsa” atau “memiliki tanggal kadaluarsa”, dan masukkan tanggal bila diperlukan.',
  'inventory.manualAdd.limitReached': 'Anda dapat menambahkan hingga {{max}} item manual.',
  'inventory.manualAdd.addFailed': 'Tidak dapat menambahkan item. Coba lagi.',
  'inventory.manualAdd.remove': 'Menghapus',
  'inventory.manualAdd.removeAria': 'Hapus item yang ditambahkan secara manual {{name}}',
  'inventory.manualAdd.rowCategoryBadge': 'Kategori: {{category}}',
  'inventory.manualAdd.rowCategoryEditLabel': 'Kategori (dapat diedit)',
  'inventory.expiry.sectionAria': 'Tanggal kadaluwarsa',
  'inventory.expiry.sectionTitle': 'Kedaluwarsa',
  'inventory.expiry.noExpiryLabel': 'Tidak ada kadaluwarsa',
  'inventory.expiry.noExpiryAria': '{{item}}: tidak ada masa berlakunya',
  'inventory.expiry.hasDatesLabel': 'Memiliki tanggal kadaluwarsa',
  'inventory.expiry.hasDatesAria': '{{item}}: masukkan tanggal kedaluwarsa',
  'inventory.expiry.datePickerAria': '{{item}} tanggal kedaluwarsa {{n}}',
  'inventory.expiry.removeDate': 'Menghapus',
  'inventory.expiry.removeDateAria': 'Hapus {{item}} tanggal kedaluwarsa {{n}}',
  'inventory.expiry.addDate': 'Tambahkan tanggal kedaluwarsa lainnya',
  'inventory.expiry.maxDatesHint': 'Hingga 10 tanggal kedaluwarsa per item.',
  'inventory.expiry.required': 'Masukkan setidaknya satu tanggal kedaluwarsa untuk “{{item}}”, atau pilih “tidak ada kedaluwarsa”.',
  'inventory.expiry.chooseModeHint': 'Pilih “tidak ada masa kadaluarsa” atau “memiliki tanggal kadaluwarsa”.',
  'inventory.expiry.choiceRequired': 'Pilih cara menangani kadaluwarsa untuk “{{item}}” (tidak ada kadaluarsa atau satu atau beberapa tanggal).',
  'inventory.reviewLinesHeading': 'Inventarisasi barang',
  'task.inventory.newTaskTitle': 'Buat Stok Rumah',
  'task.inventory.editTaskTitle': 'Edit Stok Rumah',
  'task.inventory.loadError': 'Tidak dapat memuat data inventaris',
  'task.inventory.employerOnly': 'Hanya akun perusahaan',
  'task.inventory.chainHint': 'Pembantu harus menyelesaikan Stok Rumah sesuai urutan tanggal jatuh tempo. Anda tidak dapat mengerjakan contoh selanjutnya sampai semua contoh sebelumnya disetujui. Atur pengulangan saat Anda membuat atau mengedit Stok Rumah (tidak ada dalam daftar periksa).',
  'task.inventory.listScheduleMovedHint': 'Daftar periksa hanyalah sekumpulan item baris. Atur pengulangan saat Anda membuat tugas Stok Rumah.',
  'task.inventory.editListHint': 'Setelah Anda mengubah daftar periksa, alur inventarisasi pembantu dan pengiriman berikutnya menggunakan item baris baru.',
  'task.inventory.editListItemsPreview': 'Item dalam daftar periksa ini',
  'task.inventory.editListEmpty': 'Daftar periksa ini belum memiliki item',
  'task.inventory.editChecklistItemsHeading': 'Item baris daftar periksa',
  'task.inventory.editChecklistItemsSub': 'Pilih item inventaris untuk disertakan. Pesanan mengikuti daftar inventaris Anda. Gunakan tombol simpan berwarna hijau, atau simpan tugas di bawah ini agar tetap ada.',
  'task.inventory.editTaskOptionsHeading': 'Tugas Stok Rumah',
  'task.inventory.editTaskSubmitHint': 'Untuk menyimpan daftar periksa saja, gunakan tombol hijau “Simpan item baris daftar”. Tombol utama juga menyimpan judul, deskripsi, tanggal, pemberitahuan, dan mengikat tugas ini ke daftar periksa yang dipilih.',
  'task.inventory.newTaskChecklistHint': 'Pilih item inventaris untuk daftar periksa ini. Jika Anda mengubah kotak centang, daftar akan disimpan sebelum tugas dibuat.',
  'task.inventory.sections.lists': 'Daftar periksa',
  'task.inventory.createListCta': 'Daftar periksa baru',
  'task.inventory.noListsHint': 'Belum ada daftar periksa. Buat daftar periksa dan tambahkan item baris terlebih dahulu.',
  'task.inventory.createListTitle': 'Daftar periksa baru',
  'task.inventory.listNameLabel': 'Nama daftar periksa',
  'task.inventory.scheduleLabel': 'Jadwal',
  'task.inventory.schedule.none': 'Tidak ada jadwal berulang (buat tugas secara manual)',
  'task.inventory.schedule.weekly': 'Mingguan',
  'task.inventory.schedule.monthlyFirstWday': 'Hari kerja pertama setiap bulan',
  'task.inventory.weekdayLabel': 'Hari kerja',
  'task.inventory.createListError': 'Tidak dapat membuat daftar periksa',
  'task.inventory.createListSuccess': 'Daftar periksa dibuat',
  'task.inventory.listNameRequired': 'Masukkan nama daftar periksa',
  'task.inventory.assignItemsTitle': 'Daftar periksa ini tidak memiliki item',
  'task.inventory.assignItemsHint': 'Pilih item dari inventaris Anda, atau tambahkan item baru terlebih dahulu.',
  'task.inventory.quickAddItem': 'Nama barang',
  'task.inventory.addItemCta': 'Tambahkan ke inventaris',
  'task.inventory.createItemError': 'Tidak dapat menambahkan item',
  'task.inventory.createItemSuccess': 'Item ditambahkan ke inventaris',
  'task.inventory.itemNameRequired': 'Masukkan nama item',
  'task.inventory.itemNameLabel': 'Nama barang',
  'task.inventory.renameItemCta': 'Ganti nama',
  'task.inventory.removeFromListCta': 'Hapus dari semua daftar periksa inventarisasi',
  'task.inventory.editListItemsModalCta': 'Edit item daftar periksa',
  'task.inventory.removeListCta': 'Hapus daftar periksa',
  'task.inventory.removeListConfirmTitle': 'Hapus daftar periksa Stok Rumah ini?',
  'task.inventory.removeListConfirmBody': 'Setelah penghapusan, semua tugas Stok Rumah aktif yang ditautkan ke daftar periksa ini menjadi kedaluwarsa dan harus memilih daftar periksa lain.',
  'task.inventory.removeListAffectedTasksCount': 'Jumlah tugas yang terpengaruh: {{count}}',
  'task.inventory.removeListAffectedTasksLabel': 'Tugas Stok Rumah yang Terkena Dampak:',
  'task.inventory.removeListConfirmCta': 'Hapus daftar periksa',
  'task.inventory.removeListSuccess': 'Daftar periksa dihapus',
  'task.inventory.removeListError': 'Tidak dapat menghapus daftar periksa',
  'task.inventory.updateListSuccess': 'Nama daftar periksa diperbarui',
  'task.inventory.updateListError': 'Tidak dapat memperbarui nama daftar periksa',
  'task.inventory.renameListModalTitle': 'Ganti nama daftar periksa',
  'task.inventory.renameListModalOpenCta': 'Ganti nama daftar periksa',
  'task.inventory.addedButNotSelected': 'Ditambahkan ke inventaris saja. Checklist max tercapai, jadi tidak dipilih.',
  'task.inventory.createListUseHint': 'Setelah membuat daftar periksa ini, simpan item daftar periksa terlebih dahulu untuk digunakan.',
  'task.inventory.removeFromListConfirmTitle': 'Hapus item ini dari semua daftar periksa inventarisasi?',
  'task.inventory.removeFromListConfirmBody': 'Konfirmasikan untuk menghapus? Tidak dapat membatalkan setelah dikonfirmasi.',
  'task.inventory.removeFromListConfirmCta': 'Hapus dari semua daftar periksa inventarisasi',
  'task.inventory.renameItemModalTitle': 'Ganti nama item',
  'task.inventory.renameItemSave': 'Menyimpan',
  'task.inventory.updateItemError': 'Tidak dapat memperbarui item',
  'task.inventory.maxItemsNote': '{{count}} item dipilih',
  'task.inventory.saveListItemsCta': 'Simpan item daftar periksa',
  'task.inventory.saveListItemsError': 'Tidak dapat menyimpan item',
  'task.inventory.saveListItemsSuccess': 'Item daftar periksa disimpan',
  'task.inventory.pickAtLeastOneItem': 'Pilih setidaknya satu item',
  'task.inventory.formHeading': 'Buat pekerjaan Stok Rumah',
  'task.inventory.wizard.stepOf': 'Langkah {{current}} / {{total}}',
  'task.inventory.wizard.step1Title': 'Judul & deskripsi',
  'task.inventory.wizard.step2Title': 'Lokasi',
  'task.inventory.wizard.step3Title': 'Kategori',
  'task.inventory.wizard.step4Title': 'Jadwal & tanggal',
  'task.inventory.wizard.step5Title': 'Pemberitahuan',
  'task.inventory.wizard.step6Title': 'Daftar periksa & item',
  'task.inventory.wizard.step7Title': 'Tinjau & buat',
  'task.inventory.wizard.next': 'Berikutnya',
  'task.inventory.wizard.back': 'Kembali',
  'task.inventory.wizard.reviewConfirm': 'Buat tugas',
  'task.inventory.wizard.reviewSave': 'Simpan perubahan',
  'task.inventory.wizard.categoriesHint': 'Tambahkan setidaknya satu kategori (saran di bawah).',
  'task.inventory.wizard.locationsHint': 'Tambahkan setidaknya satu lokasi (saran di bawah).',
  'task.inventory.wizard.suggestHeading': 'Saran',
  'task.inventory.suggest.location.kitchen': 'Dapur',
  'task.inventory.suggest.location.fridge': 'Kulkas',
  'task.inventory.suggest.location.storeRoom': 'Ruang Penyimpanan',
  'task.inventory.suggest.location.livingRoom': 'Ruang Tamu',
  'task.inventory.suggest.location.bathroomA': 'Kamar Mandi A',
  'task.inventory.suggest.location.bathroomB': 'Kamar Mandi B',
  'task.inventory.suggest.category.food': 'Makanan',
  'task.inventory.suggest.category.drinks': 'Minuman',
  'task.inventory.suggest.category.babyFood': 'Makanan Bayi & Anak',
  'task.inventory.suggest.category.babyDrinks': 'Minuman Bayi & Anak',
  'task.inventory.suggest.category.elderlyFood': 'Makanan Lansia',
  'task.inventory.suggest.category.petFood': 'Makanan Hewan Peliharaan',
  'task.inventory.suggest.category.dryGoods': 'Barang Kering',
  'task.inventory.suggest.category.chilledGoods': 'Barang Dingin',
  'task.inventory.wizard.addCategoryPlaceholder': 'Ketik kategori, lalu tambahkan',
  'task.inventory.wizard.addLocationPlaceholder': 'Ketik lokasi, lalu tambahkan',
  'task.inventory.wizard.addChip': 'Menambahkan',
  'task.inventory.wizard.removeChipAria': 'Hapus {{label}}',
  'task.inventory.wizard.expiryLeadsLabel': 'Beritahukan sebelum Stok Rumah habis masa berlakunya (hari)',
  'task.inventory.wizard.expiryLeadsHint': 'Opsional multi-pilih; lewati jika Anda tidak ingin peringatan kedaluwarsa.',
  'task.inventory.wizard.titleRequired': 'Judul diperlukan',
  'task.inventory.wizard.categoriesRequired': 'Tambahkan setidaknya satu kategori',
  'task.inventory.wizard.locationsRequired': 'Tambahkan setidaknya satu lokasi',
  'task.inventory.wizard.summaryTitle': 'Judul',
  'task.inventory.wizard.summaryDesc': 'Keterangan',
  'task.inventory.wizard.summaryCategories': 'Kategori',
  'task.inventory.wizard.summaryLocations': 'Lokasi',
  'task.inventory.wizard.summaryList': 'Daftar periksa',
  'task.inventory.wizard.summaryRecurrence': 'Jadwal',
  'task.inventory.wizard.summaryDueTime': 'Batas waktunya',
  'task.inventory.wizard.summaryNotify': 'Beritahu majikan setelah selesai',
  'task.inventory.wizard.summaryNotifyOn': 'Ya',
  'task.inventory.wizard.summaryNotifyOff': 'TIDAK',
  'task.inventory.wizard.summaryExpiryLeads': 'Hari habis masa berlakunya',
  'task.inventory.wizard.summaryNone': '(tidak ada)',
  'task.inventory.wizard.reviewCardHeading': 'Tugas Stok Rumah',
  'task.inventory.selectListLabel': 'Daftar periksa',
  'task.inventory.selectListPlaceholder': 'Memilih…',
  'task.inventory.selectListRequired': 'Pilih daftar periksa',
  'task.inventory.listHasNoItems': 'Daftar periksa ini belum memiliki item. Tambahkan item di atas terlebih dahulu.',
  'task.inventory.titleOptional': 'Opsional — judul default digunakan jika kosong',
  'task.inventory.titlePlaceholder': 'misalnya Stok Dapur Rumah minggu ini',
  'task.inventory.submitCreateTask': 'Buat tugas Stok Rumah',
  'task.inventory.createTaskError': 'Tidak dapat membuat tugas Stok Rumah',
  'task.inventory.createTaskSuccess': 'Tugas Stok Rumah dibuat',
  'task.inventory.dueDateInvalid': 'Pilih tanggal jatuh tempo yang valid',
  'task.complete.title': 'Selesaikan Tugas',
  'task.complete.subtitle': 'Menyerahkan bukti penyelesaian tugas',
  'task.resubmit.photoHint': 'Anda dapat menghapus foto yang salah, lalu mengambil atau memilih foto baru.',
  'task.complete.photoSection': 'Foto (1-3)',
  'task.complete.submittedPhotosOnly': 'Foto yang dikirimkan',
  'task.complete.photoHint': 'Ketuk untuk mengambil foto atau pilih dari galeri',
  'task.complete.compressingPhotos': 'Mengompresi foto…',
  'task.complete.takePhoto': 'Kamera',
  'task.complete.choosePhoto': 'Galeri',
  'task.complete.photoAlt': 'Foto tugas {{n}}',
  'task.complete.enlargePhotoAria': 'Lihat foto tugas ukuran penuh',
  'task.complete.removePhoto': 'Hapus foto',
  'task.complete.gpsSection': 'Lokasi GPS',
  'task.complete.gpsOn': 'Diaktifkan',
  'task.complete.gpsOff': 'Dengan disabilitas',
  'task.complete.gpsHint': 'Aktifkan untuk merekam lokasi Anda',
  'task.complete.noteSection': 'Catatan',
  'task.complete.notePlaceholder': 'Tambahkan catatan (opsional)...',
  'task.complete.completedAtLabel': 'Waktu selesai',
  'task.complete.completedAtRequired': 'Silakan masukkan tanggal dan waktu selesai',
  'task.complete.submit': 'Kirim',
  'task.complete.submitting': 'Mengirimkan...',
  'task.complete.submitSuccess': 'Tugas berhasil dikirimkan',
  'task.complete.submitError': 'Pengiriman gagal',
  'task.complete.photoRequired': 'Harap unggah minimal 1 foto',
  'task.complete.photoUploadError': 'Tidak dapat mengunggah foto ke penyimpanan cloud. Periksa koneksi Anda, coba lagi, dan pastikan CORS bucket GCS mengizinkan situs ini.',
  'task.complete.offlineSaved': 'Disimpan secara offline, akan disinkronkan saat online',
  'task.resubmit.title': 'Kirim Ulang Tugas',
  'task.resubmit.subtitle': 'Ubah dan kirim ulang berdasarkan umpan balik perusahaan',
  'task.resubmit.previousNote': 'Catatan sebelumnya',
  'task.resubmit.submit': 'Kirim ulang',
  'task.resubmit.submitSuccess': 'Berhasil dikirim ulang',
  'task.action.back': 'Kembali',
  'task.action.refresh': 'Menyegarkan',
  'task.action.delete': 'Menghapus',
  'task.action.archive': 'Arsip',
  'task.action.archiveConfirm': 'Apakah Anda yakin ingin mengarsipkan tugas ini?',
  'task.action.archiveSuccess': 'Tugas diarsipkan',
  'task.action.archiveError': 'Gagal mengarsipkan tugas',
};
